/**
 * Bundle Configurator
 *
 * A complete bundle builder that allows customers to:
 * - Select Korb (Form × Farbe combination)
 * - Select Bügelfarbe (filtered by Korbfarbe availability)
 * - Add/remove form-dependent accessories (with color-dependent products)
 * - Add all selected products to cart as a bundle
 */

// ═══════════════════════════════════════════════════════════════════════════════
// FACEBOOK PIXEL REDIRECT FIX FOR INSTAGRAM/FACEBOOK IN-APP BROWSER
// Must run IMMEDIATELY before anything else to prevent FB Pixel from redirecting
// ═══════════════════════════════════════════════════════════════════════════════
(function () {
  const isInAppBrowser = /FBAN|FBAV|Instagram|FB_IAB|FB4A|FBIOS/i.test(navigator.userAgent);
  if (isInAppBrowser) {
    console.log('[Bundle Configurator] 🚫 Instagram/Facebook In-App Browser detected!');
    console.log('[Bundle Configurator] 🚫 Disabling Facebook Pixel to prevent redirect');

    // Create a no-op fbq function
    const noopFbq = function () {
      console.log('[Bundle Configurator] fbq call blocked:', Array.from(arguments));
    };
    noopFbq.callMethod = function () {};
    noopFbq.queue = [];
    noopFbq.loaded = true;
    noopFbq.version = '2.0';

    // Override fbq immediately
    window.fbq = noopFbq;
    window._fbq = noopFbq;

    // Keep overriding in case FB Pixel tries to reinitialize
    Object.defineProperty(window, 'fbq', {
      get: function () {
        return noopFbq;
      },
      set: function () {
        console.log('[Bundle Configurator] Blocked attempt to set fbq');
        return noopFbq;
      },
      configurable: false,
    });
  }
})();

if (!customElements.get('bundle-configurator')) {
  class BundleConfigurator extends HTMLElement {
    constructor() {
      super();

      // ═══════════════════════════════════════════════════════════════════════
      // SELECTION STATE
      // Tracks the currently selected options in the configurator
      // ═══════════════════════════════════════════════════════════════════════
      this.selectedForm = this.dataset.selectedForm || '';     // z.B. "Classic", "Edge"
      this.selectedFarbe = this.dataset.selectedFarbe || '';   // Korbfarbe z.B. "Weiß", "Natur"
      this.selectedBuegel = this.dataset.selectedBuegel || ''; // Bügelfarbe z.B. "gold", "silber"
      this.selectedBuegelSecondary = this.dataset.selectedBuegelSecondary || ''; // Zweite Bügelfarbe (für Style Bundle)
      this.isBundle = this.dataset.isBundle === 'true';        // Ob Pflicht-Zubehör vorausgewählt
      this.allowSecondaryBuegel = this.dataset.allowSecondaryBuegel === 'true'; // Zweite Bügelfarbe aktiviert

      // ═══════════════════════════════════════════════════════════════════════
      // PRODUCT DATA MAPPINGS (aus Liquid/JSON geladen)
      // Diese Arrays enthalten alle verfügbaren Produkt-Kombinationen
      // ═══════════════════════════════════════════════════════════════════════

      // korbMappings: Form × Farbe → Shopify Variant
      // Struktur: [{ form, farbe, variantId, productId, price, available }]
      this.korbMappings = [];

      // buegelOptionen: UI-only Liste der Bügelfarben für die Buttons
      // Struktur: [{ value, label, colorHex }]
      this.buegelOptionen = [];

      // buegelMappings: Korbfarbe × Bügelfarbe → Shopify Variant
      // Struktur: [{ korbFarbe, buegelFarbe, variantId, productId, price, available }]
      this.buegelMappings = [];

      // zubehoerMappings: Zubehör-Key × Korbfarbe → Shopify Variant
      // Struktur: [{ zubehoerKey, korbFarbe, variantId, productId, price, productTitle, image, available }]
      // Fallback: korbFarbe="all" für farbneutrale Zubehörteile
      this.zubehoerMappings = [];

      // gratisgeschenke: Free gift products with variant selection
      // Struktur: [{ key, label, productId, productTitle, vorausgewaehlt, variants: [...] }]
      this.gratisgeschenke = [];

      // Allgemeine Konfig (moneyFormat, setRabattProzent, etc.)
      this.config = {};

      // ═══════════════════════════════════════════════════════════════════════
      // ALLOW_* FLAGS (Static/Dynamic Bundle Control)
      // Control which sections are editable vs locked
      // ═══════════════════════════════════════════════════════════════════════
      this.allowFormChange = this.dataset.allowFormChange !== 'false';
      this.allowColorChange = this.dataset.allowColorChange !== 'false';
      this.allowBuegelChange = this.dataset.allowBuegelChange !== 'false';
      this.allowAccessoryChange = this.dataset.allowAccessoryChange !== 'false';
      this.showZubehoer = this.dataset.showZubehoer === 'true';
      this.allowUrlChange = this.dataset.allowUrlChange !== 'false'; // Ob die URL (Pathname) geändert werden soll

      // ═══════════════════════════════════════════════════════════════════════
      // AVAILABILITY STATE
      // Tracks which items are currently out of stock
      // Used to disable add-to-cart button and show warnings
      // ═══════════════════════════════════════════════════════════════════════
      this.unavailableItems = {
        korb: false,        // true wenn Form×Farbe Kombi ausverkauft
        buegel: false,      // true wenn Bügelfarbe ausverkauft
        accessories: [],    // Array von accessoryKeys die ausverkauft sind
      };

      // ═══════════════════════════════════════════════════════════════════════
      // UI FLAGS
      // Steuern wann bestimmte Updates ausgeführt werden
      // ═══════════════════════════════════════════════════════════════════════

      // Verhindert URL-Update beim ersten Laden (sonst wird History-Eintrag erstellt)
      this.isInitialLoad = true;

      // AbortController für Fetch-Requests (um vorherige Requests bei schnellen Klicks abzubrechen)
      this.imageLoadAbortController = null;
      // Sicherheits-Timeout für Loading-State (falls onload/onerror nicht feuern)
      this.loadingTimeoutId = null;
      // Verhindert Bild/Titel-Update bis User tatsächlich klickt
      // (bei URL-Params soll das initiale Bild aus dem Liquid kommen)
      this.hasUserInteracted = false;

      // DOM elements
      this.formButtons = this.querySelectorAll('[data-option-type="form"]');
      this.farbeButtons = this.querySelectorAll('[data-option-type="farbe"]');
      this.buegelButtons = this.querySelectorAll('[data-option-type="buegel"]:not([data-buegel-sequence="secondary"])');
      this.buegelButtonsSecondary = this.querySelectorAll('[data-option-type="buegel"][data-buegel-sequence="secondary"]');
      this.accessoryItems = this.querySelectorAll('[data-accessory-item]');
      this.giftItems = this.querySelectorAll('[data-gift-item]');
      this.giftsSection = this.querySelector('[data-section="gratisgeschenke"]');
      this.selectAllBtn = this.querySelector('[data-select-all-accessories]');

      // Summary elements
      this.summaryLieblingskorb = this.querySelector('[data-summary-lieblingskorb]');
      this.summaryAccessories = this.querySelector('[data-summary-accessories]');
      this.summaryAccessoriesValue = this.querySelector('[data-summary-accessories-value]');
      this.summaryDiscount = this.querySelector('[data-summary-discount]');
      this.summaryTotal = this.querySelector('[data-summary-total]');
      this.summaryCompare = this.querySelector('[data-summary-compare]');
      this.summarySublabel = this.querySelector('[data-summary-sublabel]');
      this.discountRow = this.querySelector('[data-discount-row]');
      this.accessoriesRow = this.querySelector('[data-summary-accessories-row]');

      // Banners
      this.warningBanner = this.querySelector('[data-warning-banner]');
      this.successBanner = this.querySelector('[data-success-banner]');
      this.missingList = this.querySelector('[data-missing-list]');
      this.savingsText = this.querySelector('[data-savings-text]');

      // Savings hint
      this.savingsHint = this.querySelector('[data-savings-hint]');
      this.savingsHintText = this.querySelector('[data-savings-hint-text]');

      // Label elements
      this.formLabel = this.querySelector('[data-selected-label="form"]');
      this.farbeLabel = this.querySelector('[data-selected-label="farbe"]');
      this.buegelLabel = this.querySelector('[data-selected-label="buegel"]');
      this.buegelLabelSecondary = this.querySelector('[data-selected-label="buegel-secondary"]');

      // Secondary buegel validation hint
      this.secondaryBuegelHint = this.querySelector('[data-secondary-buegel-hint]');
      this.buegelDeliveryHint = this.querySelector('[data-buegel-delivery-hint]');

      // Mobile sticky cart elements (outside bundle-configurator, so use document.querySelector)
      this.stickyCart = document.querySelector('[data-sticky-cart]');
      this.stickyImage = document.querySelector('[data-sticky-image]');
      this.stickyTotal = document.querySelector('[data-sticky-total]');
      this.stickyCompare = document.querySelector('[data-sticky-compare]');
      this.stickyBadge = document.querySelector('[data-sticky-badge]');
      this.stickyBadgeCount = document.querySelector('[data-sticky-badge-count]');
      this.stickyAddToCartBtn = document.querySelector('[data-sticky-add-to-cart]');
    }

    connectedCallback() {
      this.loadData();
      this.loadStateFromUrl();
      this.bindEvents();
      this.bindPopstateHandler();
      this.applyInitialState();
      this.updateFarbeAvailability();
      this.updateBuegelAvailability();
      this.updateAccessoryVisibility();
      this.updateAccessoryProducts();
      this.checkKorbAvailability();
      this.updateAccessoryAvailability();
      this.updatePriceSummary();
      this.updateBanners();
      this.updateAccessoryOverlay();
      this.updateSavingsHint();
      this.initStickyCart();
      this.bindGallerySlideEvents();
      // Remove loading state from accessories container
      this.revealAccessories();
      this.initReadonlyAccessories();
      // Update product title based on initial selection (delayed to ensure DOM is ready)
      // Note: Product image is NOT updated on initial load - only when user changes Form/Farbe/Bügel
      setTimeout(() => {
        this.updateProductTitle();
        // Clear the initial load flag AFTER all initial setup is complete
        // This ensures the first user interaction will update the URL
        this.isInitialLoad = false;
      }, 100);
    }

    /**
     * Bind popstate handler for browser back/forward navigation
     */
    bindPopstateHandler() {
      window.addEventListener('popstate', (event) => {
        // console.log('=== POPSTATE EVENT ===');
        // console.log('event.state:', event.state);
        // console.log('current URL:', window.location.href);
        // console.log('current pathname:', window.location.pathname);
        // console.log('current search:', window.location.search);

        // Reload state from URL and apply it
        this.loadStateFromUrl();
        this.applyInitialState();
        this.updateFarbeAvailability();
        this.updateBuegelAvailability();
        this.updateAccessoryVisibility();
        this.updateAccessoryProducts();
        this.checkKorbAvailability();
        this.updateAccessoryAvailability();
        this.updatePriceSummary();
        this.updateBanners();
        this.updateAccessoryOverlay();
        this.updateSavingsHint();
        this.updateMainProductImage();
        this.updateProductTitle();
      });
    }

    /**
     * Load state from URL parameters
     */
    loadStateFromUrl() {
      const params = new URLSearchParams(window.location.search);

      // console.log('=== loadStateFromUrl() ===');
      // console.log('URL params:', window.location.search);

      // Load form from URL (lk_form) or fall back to dataset default
      const urlForm = params.get('lk_form');
      this.selectedForm = urlForm || this.dataset.selectedForm || '';
      // console.log('urlForm:', urlForm, '-> selectedForm:', this.selectedForm);

      // Load farbe from URL (lk_farbe) or fall back to dataset default
      const urlFarbe = params.get('lk_farbe');
      this.selectedFarbe = urlFarbe || this.dataset.selectedFarbe || '';
      // console.log('urlFarbe:', urlFarbe, '-> selectedFarbe:', this.selectedFarbe);

      // Load buegel from URL (lk_buegel) or fall back to dataset default
      const urlBuegel = params.get('lk_buegel');
      this.selectedBuegel = urlBuegel || this.dataset.selectedBuegel || '';
      // console.log('urlBuegel:', urlBuegel, '-> selectedBuegel:', this.selectedBuegel);

      // Load secondary buegel from URL (lk_buegel2) or fall back to dataset default
      const urlBuegel2 = params.get('lk_buegel2');
      this.selectedBuegelSecondary = urlBuegel2 || this.dataset.selectedBuegelSecondary || '';
      // console.log('urlBuegel2:', urlBuegel2, '-> selectedBuegelSecondary:', this.selectedBuegelSecondary);

      // Load accessories from URL (lk_acc - comma-separated keys)
      const urlAccessories = params.get('lk_acc');
      if (urlAccessories !== null) {
        this.urlAccessories = urlAccessories ? urlAccessories.split(',') : [];
        this.hasUrlAccessories = true;
      } else {
        this.hasUrlAccessories = false;
      }
      // console.log('urlAccessories:', urlAccessories, '-> hasUrlAccessories:', this.hasUrlAccessories);
    }

    /**
     * Apply initial state to UI (after loading from URL)
     */
    applyInitialState() {
      // Apply form selection (case-insensitive comparison)
      this.formButtons.forEach((btn) => {
        const isSelected = this.normalizeValue(btn.dataset.optionValue) === this.normalizeValue(this.selectedForm);
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      if (this.formLabel) {
        this.formLabel.textContent = this.selectedForm;
      }

      // Apply farbe selection (case-insensitive comparison)
      this.farbeButtons.forEach((btn) => {
        const isSelected = this.normalizeValue(btn.dataset.optionValue) === this.normalizeValue(this.selectedFarbe);
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      if (this.farbeLabel) {
        this.farbeLabel.textContent = this.selectedFarbe;
      }

      // Apply buegel selection (case-insensitive comparison)
      this.buegelButtons.forEach((btn) => {
        const isSelected = this.normalizeValue(btn.dataset.optionValue) === this.normalizeValue(this.selectedBuegel);
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        if (isSelected && this.buegelLabel) {
          this.buegelLabel.textContent = btn.dataset.optionLabel || this.selectedBuegel;
        }
      });

      // Apply initial buegel delivery hint
      if (this.buegelDeliveryHint) {
        const buegelData = this.getSelectedBuegelData('primary');
        const hint = (buegelData?.deliveryHint || '').trim();
        if (hint) {
          this.buegelDeliveryHint.textContent = `Lieferzeit: ${hint}`;
          this.buegelDeliveryHint.hidden = false;
        }
      }

      // Apply secondary buegel selection (case-insensitive comparison)
      if (this.allowSecondaryBuegel) {
        this.buegelButtonsSecondary.forEach((btn) => {
          const isSelected = this.normalizeValue(btn.dataset.optionValue) === this.normalizeValue(this.selectedBuegelSecondary);
          btn.classList.toggle('is-selected', isSelected);
          btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          if (isSelected && this.buegelLabelSecondary) {
            this.buegelLabelSecondary.textContent = btn.dataset.optionLabel || this.selectedBuegelSecondary;
          }
        });
      }

      // Apply accessory selection from URL (if provided)
      if (this.hasUrlAccessories) {
        // console.log('=== applyInitialState: Applying URL accessories ===');
        // console.log('urlAccessories:', this.urlAccessories);
        this.accessoryItems.forEach((item) => {
          const checkbox = item.querySelector('input[type="checkbox"]');
          if (checkbox && !checkbox.disabled) {
            const key = item.dataset.accessoryKey;
            const shouldBeChecked = this.urlAccessories.includes(key);
            // console.log(`  key="${key}", shouldBeChecked=${shouldBeChecked}, hidden=${item.hidden}`);
            checkbox.checked = shouldBeChecked;
            item.classList.toggle('is-selected', shouldBeChecked);
          }
        });
      }
    }

    /**
     * Update URL with current state
     */
    updateUrl() {
      // Skip URL update on initial page load to avoid creating a history entry
      // The flag is cleared in connectedCallback after initial setup is complete
      if (this.isInitialLoad) {
        // console.log('=== updateUrl() SKIPPED (initial load) ===');
        return;
      }

      const params = new URLSearchParams(window.location.search);

      // Set form
      if (this.selectedForm) {
        params.set('lk_form', this.selectedForm);
      }

      // Set farbe
      if (this.selectedFarbe) {
        params.set('lk_farbe', this.selectedFarbe);
      }

      // Set buegel (primary)
      if (this.selectedBuegel) {
        params.set('lk_buegel', this.selectedBuegel);
      }

      // Set buegel2 (secondary - for Style Bundle)
      if (this.allowSecondaryBuegel && this.selectedBuegelSecondary) {
        params.set('lk_buegel2', this.selectedBuegelSecondary);
      } else {
        params.delete('lk_buegel2');
      }

      // Set accessories (comma-separated keys of selected items)
      const selectedAccessories = [];
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        
        // Check if this item belongs to a bundle group
        const bundleGroupName = item.dataset.bundleGroup;
        if (bundleGroupName) {
          const parentBundle = this.querySelector(`[data-accessory-bundle][data-bundle-group="${bundleGroupName}"]`);
          if (parentBundle) {
            const bundleCheckbox = parentBundle.querySelector('[data-bundle-checkbox]');
            if (!bundleCheckbox || !bundleCheckbox.checked) {
              return; // Skip if bundle is not checked
            }
          }
        }
        
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          selectedAccessories.push(item.dataset.accessoryKey);
        }
      });
      params.set('lk_acc', selectedAccessories.join(','));

      // Get product handle from produktbilder (Form × Korbfarbe × Bügelfarbe → Handle)
      // Only change pathname if allowUrlChange is true
      let pathname = window.location.pathname;
      if (this.allowUrlChange && this.produktbilder && this.produktbilder.length > 0) {
        const selectedFormNorm = this.normalizeValue(this.selectedForm);
        const selectedFarbeNorm = this.normalizeValue(this.selectedFarbe);
        const selectedBuegelNorm = this.normalizeValue(this.selectedBuegel);

        const matching = this.produktbilder.find((p) => {
          return (
            this.normalizeValue(p.form) === selectedFormNorm &&
            this.normalizeValue(p.korbFarbe) === selectedFarbeNorm &&
            this.normalizeValue(p.buegelFarbe) === selectedBuegelNorm
          );
        });

        if (matching && matching.productHandle) {
          pathname = `/products/${matching.productHandle}`;
        }
      }

      // Update URL without reload - use pushState for browser history navigation
      const newUrl = `${pathname}?${params.toString()}`;
      const currentUrl = `${window.location.pathname}${window.location.search}`;

      // console.log('=== updateUrl() ===');
      // console.log('newUrl:', newUrl);
      // console.log('currentUrl:', currentUrl);
      // console.log('URLs different:', newUrl !== currentUrl);

      // Only push if URL actually changed (avoid duplicate history entries)
      if (newUrl !== currentUrl) {
        // console.log('Pushing new URL to history');
        window.history.pushState({ configuratorState: true }, '', newUrl);
      }

      // Always notify upsell embed (farbe/form may change even if URL string matches)
      if (typeof this.notifyUpsellSelectionChange === 'function') {
        this.notifyUpsellSelectionChange('url');
      }
    }

    loadData() {
      // Load korb mappings
      const korbMappingsEl = this.querySelector('[data-korb-mappings]');
      if (korbMappingsEl) {
        try {
          this.korbMappings = JSON.parse(korbMappingsEl.textContent);
        } catch (e) {
          // console.error('Failed to parse korb mappings:', e);
        }
      }

      // Load bügel optionen (UI-only)
      const buegelOptionenEl = this.querySelector('[data-buegel-optionen]');
      if (buegelOptionenEl) {
        try {
          this.buegelOptionen = JSON.parse(buegelOptionenEl.textContent);
        } catch (e) {
          // console.error('Failed to parse bügel optionen:', e);
        }
      }

      // Load bügel mappings (Korbfarbe × Bügelfarbe → Produkt)
      const buegelMappingsEl = this.querySelector('[data-buegel-mappings]');
      if (buegelMappingsEl) {
        try {
          this.buegelMappings = JSON.parse(buegelMappingsEl.textContent);
        } catch (e) {
          // console.error('Failed to parse bügel mappings:', e);
        }
      }

      // Load zubehör mappings (Zubehör-Key × Korbfarbe → Produkt)
      const zubehoerMappingsEl = this.querySelector('[data-zubehoer-mappings]');
      if (zubehoerMappingsEl) {
        try {
          this.zubehoerMappings = JSON.parse(zubehoerMappingsEl.textContent);
        } catch (e) {
          // console.error('Failed to parse zubehör mappings:', e);
        }
      }

      // Load gratisgeschenk-optionen (free gifts with product selection)
      const gratisgeschenkOptionenEl = this.querySelector('[data-gratisgeschenk-optionen]');
      if (gratisgeschenkOptionenEl) {
        try {
          this.gratisgeschenke = JSON.parse(gratisgeschenkOptionenEl.textContent);
        } catch (e) {
          // console.error('Failed to parse gratisgeschenk-optionen:', e);
          this.gratisgeschenke = [];
        }
      }

      // Load produktbilder mappings (Form × Korbfarbe × Bügelfarbe → Bild)
      const produktbilderEl = this.querySelector('[data-produktbilder]');
      if (produktbilderEl) {
        try {
          this.produktbilder = JSON.parse(produktbilderEl.textContent);
        } catch (e) {
          // console.error('Failed to parse produktbilder:', e);
          this.produktbilder = [];
        }
      } else {
        this.produktbilder = [];
      }

      // Load config
      const configEl = this.querySelector('[data-config]');
      if (configEl) {
        try {
          this.config = JSON.parse(configEl.textContent);
        } catch (e) {
          // console.error('Failed to parse config:', e);
        }
      }

      // Load bundle app config (from shop metafield)
      // Both Function Studio configs are parsed INDEPENDENTLY to avoid node ID conflicts
      // (Function Studio reuses the same node IDs like "node_5" across different functions).
      // We combine only the final bundleRules arrays, not the raw nodes/edges.
      const bundleConfigEl = this.querySelector('[data-bundle-config]');
      if (bundleConfigEl) {
        try {
          let rawText = bundleConfigEl.textContent.trim();
          // Remove leading/trailing quotes if present (metafield stores as string)
          if (rawText.startsWith('"') && rawText.endsWith('"')) {
            rawText = rawText.slice(1, -1);
          }
          // Unescape the JSON string
          rawText = rawText.replace(/\\"/g, '"').replace(/\\\\/g, '\\');
          this.bundleConfig = JSON.parse(rawText);
          this.parseBundleConfig();
          const rules1 = [...this.bundleRules];

          // Parse second Function Studio metafield (custom.function_studio_2) independently
          const bundleConfigEl2 = this.querySelector('[data-bundle-config-2]');
          if (bundleConfigEl2) {
            try {
              let rawText2 = bundleConfigEl2.textContent.trim();
              if (rawText2.startsWith('"') && rawText2.endsWith('"')) {
                rawText2 = rawText2.slice(1, -1);
              }
              rawText2 = rawText2.replace(/\\"/g, '"').replace(/\\\\/g, '\\');
              this.bundleConfig = JSON.parse(rawText2);
              this.parseBundleConfig();
              // Combine rules from both functions
              this.bundleRules = [...rules1, ...this.bundleRules];
            } catch (e2) {
              // console.error('Failed to parse bundle config 2:', e2);
              this.bundleRules = rules1;
            }
          }
        } catch (e) {
          // console.error('Failed to parse bundle config:', e);
          this.bundleConfig = null;
          this.bundleRules = [];
        }
      }
    }

    /**
     * Parse bundle config and extract pricing rules
     *
     * HINTERGRUND:
     * Die Bundle-Konfiguration kommt aus der Shopify Flow App (Bundle Bear o.ä.).
     * Sie ist als Graph-Struktur gespeichert mit nodes und edges.
     *
     * STRUKTUR DER bundleConfig:
     * {
     *   nodes: [
     *     { id: "1", data: { actionType: "set-groups", groups: [...] } },   // Definiert Produktgruppen
     *     { id: "2", data: { actionType: "bundle-discount", price_per_set: 249, ... } }  // Definiert Rabatt
     *   ],
     *   edges: [
     *     { source: "1", target: "2" }  // Verbindet Gruppe mit Rabatt
     *   ]
     * }
     *
     * ERGEBNIS (this.bundleRules):
     * Array von Regeln, jede enthält:
     * - name: Name des Bundles (z.B. "LIEBLINGSKORB Set")
     * - pricePerSet: Festpreis in CENTS (z.B. 24900 = 249€)
     * - pricingMode: true wenn Festpreis-Modus aktiv
     * - components: Array von { group_name } - welche Gruppen das Bundle bilden
     * - groups: { [groupId]: { name, productIds: [...] } } - Produkte pro Gruppe
     */
    parseBundleConfig() {
      this.bundleRules = [];
      if (!this.bundleConfig || !this.bundleConfig.nodes) return;

      // "set-groups" Nodes definieren welche Produkte zu welcher Gruppe gehören
      // z.B. Gruppe "Korb" enthält alle Korb-Varianten, Gruppe "Deckel" alle Deckel
      const groupNodes = this.bundleConfig.nodes.filter(
        (n) => n.data && n.data.actionType === 'set-groups'
      );

      // "bundle-discount" Nodes definieren den Bundle-Preis und welche Gruppen kombiniert werden
      const discountNodes = this.bundleConfig.nodes.filter(
        (n) => n.data && n.data.actionType === 'bundle-discount'
      );

      // Für jeden Discount-Node eine vollständige Regel aufbauen
      discountNodes.forEach((discountNode) => {
        const rule = {
          name: discountNode.data.message || 'Bundle',
          pricePerSet: parseFloat(discountNode.data.price_per_set) * 100 || 0, // Euro → Cents
          pricingMode: discountNode.data.pricing_mode || false, // true = Festpreis-Modus
          components: discountNode.data.bundle_components || [], // Welche Gruppen gehören zum Bundle
          groups: {},
        };

        // Finde den verbundenen Group-Node über die edges (Graph-Kante)
        const connectedGroupNodeId = this.findConnectedGroupNode(discountNode.id);
        const groupNode = groupNodes.find((n) => n.id === connectedGroupNodeId);

        // Extrahiere alle Produkt-IDs aus den Gruppen-Conditions
        if (groupNode && groupNode.data.groups) {
          groupNode.data.groups.forEach((group) => {
            rule.groups[group.id] = {
              name: group.name, // z.B. "Korb", "Bügelset", "Deckel"
              productIds: this.extractProductIds(group.conditions),
            };
          });
        }

        this.bundleRules.push(rule);
      });
    }

    /**
     * Find connected group node via edges
     */
    findConnectedGroupNode(discountNodeId) {
      if (!this.bundleConfig.edges) return null;

      // Find edge where discount node is the target
      const edge = this.bundleConfig.edges.find((e) => e.target === discountNodeId);
      return edge ? edge.source : null;
    }

    /**
     * Extract product IDs from conditions
     *
     * SHOPIFY GID FORMAT:
     * - Products: "gid://shopify/Product/123456789"
     * - Variants: "gid://shopify/ProductVariant/123456789"
     *
     * PROBLEM:
     * Einige Bundle-Apps speichern Product IDs, andere Variant IDs.
     * Der Korb wird über Variant-IDs referenziert (weil es ein Produkt mit vielen Varianten ist),
     * aber Zubehör oft über Product-IDs (weil es separate Produkte sind).
     *
     * LÖSUNG:
     * - Product IDs werden als Number gespeichert: 123456789
     * - Variant IDs werden als String mit Prefix gespeichert: "v_123456789"
     * - Beim Matching werden beide Formate verglichen
     *
     * @param {Array} conditions - Array von Flow-Conditions aus der Bundle-App
     * @returns {Array} Array von IDs (Number für Products, String "v_xxx" für Variants)
     */
    extractProductIds(conditions) {
      const ids = [];
      if (!conditions) return ids;

      conditions.forEach((condition) => {
        if (condition.value && Array.isArray(condition.value)) {
          condition.value.forEach((item) => {
            if (item.id) {
              // Versuche Product ID zu extrahieren (z.B. "gid://shopify/Product/123")
              const productMatch = item.id.match(/Product\/(\d+)/);
              if (productMatch) {
                ids.push(parseInt(productMatch[1], 10));
                return;
              }
              // Versuche Variant ID zu extrahieren (z.B. "gid://shopify/ProductVariant/456")
              const variantMatch = item.id.match(/ProductVariant\/(\d+)/);
              if (variantMatch) {
                // Prefix "v_" um Variants von Products zu unterscheiden
                ids.push('v_' + variantMatch[1]);
              }
            }
          });
        }
      });

      return ids;
    }

    /**
     * Check if a bundle rule is satisfied and return the matching rule
     *
     * BUNDLE-MATCHING LOGIK:
     *
     * Das System unterstützt mehrere Bundle-Regeln (z.B. 2er-Set, 3er-Set, Komplett-Set).
     * Jede Regel definiert:
     * - Welche Produktgruppen enthalten sein müssen (components)
     * - Wie viele Produkte aus jeder Gruppe benötigt werden (required_quantity)
     * - Einen Festpreis wenn alle Gruppen erfüllt sind (pricePerSet)
     *
     * BEISPIEL:
     * - Basic Bundle: Korb(1) + Deckel(1) + Einlegeboden(1) + Bügelset(1) = 139€
     * - Style Bundle: Korb(1) + Deckel(1) + Einlegeboden(1) + Bügelset(2) = 154,85€
     *   (erfordert 2 VERSCHIEDENE Bügelfarben!)
     *
     * MATCHING-PRIORITÄT:
     * 1. EXACT MATCH: Summe aller required_quantity === Anzahl ausgewählter Bundle-Produkte
     *    (Wenn User genau die richtige Anzahl wählt, greift das passende Bundle)
     * 2. Bei mehreren Matches: Regel mit höherer Summe der required_quantity gewinnt
     *
     * @returns {Object|null} Die beste passende Bundle-Regel oder null
     */
    getMatchingBundleRule() {
      if (!this.bundleRules || this.bundleRules.length === 0) return null;

      // Sammle alle aktuell ausgewählten Produkt-IDs (Korb + Bügel + Zubehör)
      const selectedProductIds = this.getSelectedProductIds();

      // Zähle wie viele "bundle-relevante" Produkte ausgewählt sind
      // (Nur Produkte die Teil einer Bundle-Komponente sind, nicht Extra-Zubehör)
      const allBundleProductIds = new Set();
      this.bundleRules.forEach((rule) => {
        rule.components.forEach((component) => {
          const group = rule.groups[component.group_name];
          if (group) {
            group.productIds.forEach((pid) => allBundleProductIds.add(pid));
          }
        });
      });
      const selectedBundleProductCount = selectedProductIds.filter((pid) =>
        allBundleProductIds.has(pid)
      ).length;

      // Prüfe alle Regeln und sammle die passenden
      const matchingRules = [];

      for (const rule of this.bundleRules) {
        let allComponentsSatisfied = true;

        // Prüfe ob für JEDE Komponente der Regel GENUG Produkte ausgewählt sind
        for (const component of rule.components) {
          const group = rule.groups[component.group_name];
          if (!group) {
            allComponentsSatisfied = false;
            break;
          }

          // required_quantity aus der Komponente (default: 1)
          const requiredQuantity = component.required_quantity || 1;

          // Zähle wie viele Produkte aus dieser Gruppe ausgewählt sind
          const matchingProductCount = group.productIds.filter((pid) =>
            selectedProductIds.includes(pid)
          ).length;

          // Prüfe ob genug Produkte aus dieser Gruppe ausgewählt sind
          if (matchingProductCount < requiredQuantity) {
            allComponentsSatisfied = false;
            break;
          }
        }

        if (allComponentsSatisfied) {
          // Berechne die Summe aller required_quantity Werte für diese Regel
          const totalRequiredQuantity = rule.components.reduce(
            (sum, comp) => sum + (comp.required_quantity || 1),
            0
          );

          // Exact Match = Summe aller required_quantity entspricht Anzahl ausgewählter Bundle-Produkte
          // Verhindert dass z.B. 3er-Set greift wenn nur 2 Bundle-Produkte ausgewählt
          const isExactMatch = totalRequiredQuantity === selectedBundleProductCount;

          matchingRules.push({
            rule,
            componentCount: totalRequiredQuantity,
            isExactMatch,
          });
        }
      }

      if (matchingRules.length === 0) {
        return null;
      }

      // Sortiere: Exact Matches zuerst, dann nach Anzahl Komponenten (höher = besser)
      matchingRules.sort((a, b) => {
        if (a.isExactMatch && !b.isExactMatch) return -1;
        if (!a.isExactMatch && b.isExactMatch) return 1;
        return b.componentCount - a.componentCount;
      });

      return matchingRules[0].rule;
    }

    /**
     * Get matching bundle rule for HYPOTHETICAL selection
     *
     * ZWECK:
     * Berechnet welche Bundle-Regel greifen WÜRDE, wenn der User noch fehlende
     * empfohlene Zubehörteile hinzufügen würde. Wird für den "Savings Hint" verwendet.
     *
     * BEISPIEL:
     * User hat: Korb + Deckel ausgewählt (erfüllt 2er-Set für 199€)
     * Fehlend: Einlegeboden (empfohlen)
     * → Diese Methode prüft: Wenn User Einlegeboden hinzufügt, greift dann 3er-Set für 219€?
     * → Falls ja: "Für nur 20€ mehr erhältst du den Einlegeboden dazu"
     *
     * @param {Array} missingAccessories - Array von { label, price, productId }
     * @returns {Object|null} Die Bundle-Regel die greifen würde
     */
    getMatchingBundleRuleHypothetical(missingAccessories) {
      if (!this.bundleRules || this.bundleRules.length === 0) return null;

      // Get currently selected product IDs
      const selectedProductIds = this.getSelectedProductIds();

      // Add the product IDs of the missing accessories (simulate them being selected)
      const missingProductIds = missingAccessories
        .filter((acc) => acc.productId && !isNaN(acc.productId))
        .map((acc) => acc.productId);

      // Combine current + hypothetical product IDs
      const hypotheticalProductIds = [...selectedProductIds, ...missingProductIds];

      // Count how many unique "bundle-relevant" products are in hypothetical selection
      // Only count products that are part of bundle components (not all groups)
      const allBundleProductIds = new Set();
      this.bundleRules.forEach((rule) => {
        rule.components.forEach((component) => {
          const group = rule.groups[component.group_name];
          if (group) {
            group.productIds.forEach((pid) => allBundleProductIds.add(pid));
          }
        });
      });
      const hypotheticalBundleProductCount = hypotheticalProductIds.filter((pid) =>
        allBundleProductIds.has(pid)
      ).length;

      // Find all matching rules and score them
      const matchingRules = [];

      for (const rule of this.bundleRules) {
        let allComponentsSatisfied = true;

        for (const component of rule.components) {
          const group = rule.groups[component.group_name];
          if (!group) {
            allComponentsSatisfied = false;
            break;
          }

          // required_quantity aus der Komponente (default: 1)
          const requiredQuantity = component.required_quantity || 1;

          // Zähle wie viele Produkte aus dieser Gruppe ausgewählt sind
          const matchingProductCount = group.productIds.filter((pid) =>
            hypotheticalProductIds.includes(pid)
          ).length;

          // Prüfe ob genug Produkte aus dieser Gruppe ausgewählt sind
          if (matchingProductCount < requiredQuantity) {
            allComponentsSatisfied = false;
            break;
          }
        }

        if (allComponentsSatisfied) {
          // Berechne die Summe aller required_quantity Werte für diese Regel
          const totalRequiredQuantity = rule.components.reduce(
            (sum, comp) => sum + (comp.required_quantity || 1),
            0
          );

          // Exact Match = Summe aller required_quantity entspricht Anzahl ausgewählter Bundle-Produkte
          const isExactMatch = totalRequiredQuantity === hypotheticalBundleProductCount;

          matchingRules.push({
            rule,
            componentCount: totalRequiredQuantity,
            isExactMatch,
          });
        }
      }

      if (matchingRules.length === 0) return null;

      // Sort: 1. Exact matches first, 2. Then by component count (descending)
      matchingRules.sort((a, b) => {
        if (a.isExactMatch && !b.isExactMatch) return -1;
        if (!a.isExactMatch && b.isExactMatch) return 1;
        return b.componentCount - a.componentCount;
      });

      return matchingRules[0].rule;
    }

    /**
     * Get all currently selected product IDs for bundle matching
     * Uses the REAL product IDs that will be added to cart (not fake product IDs)
     */
    getSelectedProductIds() {
      const ids = [];

      // Selected Korb - add BOTH variant ID (with v_ prefix) and product ID
      const korbData = this.getSelectedKorbData();
      if (korbData) {
        // Add variant ID with prefix (for matching against Flow's Korb group which uses variant IDs)
        if (korbData.variantId) {
          ids.push('v_' + korbData.variantId);
        }
        // Also add product ID for backwards compatibility
        if (korbData.productId) {
          const parsedId = parseInt(korbData.productId, 10);
          if (!isNaN(parsedId)) {
            ids.push(parsedId);
          }
        }
      }

      // Selected primary Bügel product ID
      const buegelData = this.getSelectedBuegelData('primary');
      if (buegelData && buegelData.productId) {
        const parsedId = parseInt(buegelData.productId, 10);
        if (!isNaN(parsedId)) {
          ids.push(parsedId);
        }
      }

      // Selected secondary Bügel product ID (if enabled)
      if (this.allowSecondaryBuegel) {
        const buegelDataSecondary = this.getSelectedBuegelData('secondary');
        if (buegelDataSecondary && buegelDataSecondary.productId) {
          const parsedId = parseInt(buegelDataSecondary.productId, 10);
          if (!isNaN(parsedId)) {
            ids.push(parsedId);
          }
        }
      }

      // Selected accessories
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          const productId = checkbox.dataset.accessoryProductId;
          if (productId) {
            const parsedId = parseInt(productId, 10);
            if (!isNaN(parsedId)) {
              ids.push(parsedId);
            }
          }
        }
      });

      // console.log('getSelectedProductIds:', ids);
      return ids;
    }

    bindEvents() {
      // Form buttons
      this.formButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.handleFormSelect(btn));
      });

      // Farbe buttons
      this.farbeButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.handleFarbeSelect(btn));
      });

      // Bügel buttons (primary)
      this.buegelButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.handleBuegelSelect(btn, true, 'primary'));
      });

      // Bügel buttons (secondary - for Style Bundle)
      if (this.allowSecondaryBuegel) {
        this.buegelButtonsSecondary.forEach((btn) => {
          btn.addEventListener('click', () => this.handleBuegelSelect(btn, true, 'secondary'));
        });
      }

      // Accessory checkboxes + bundle group checkboxes — skip entirely in readonly mode
      this.accessoryBundles = this.querySelectorAll('[data-accessory-bundle]');
      if (this.allowAccessoryChange || !this.showZubehoer) {
        // Only bind to items NOT in a bundle group (bundle items are controlled by bundle checkbox)
        this.accessoryItems.forEach((item) => {
          const checkbox = item.querySelector('input[type="checkbox"]');
          const bundleGroup = item.dataset.bundleGroup;
          if (checkbox && !checkbox.disabled && !bundleGroup) {
            checkbox.addEventListener('change', () => {
              this.handleAccessoryChange(item, checkbox);
            });
          }
        });

        // Bundle group checkboxes - control all items in the bundle
        this.accessoryBundles.forEach((bundle) => {
          const checkbox = bundle.querySelector('[data-bundle-checkbox]');
          if (checkbox) {
            checkbox.addEventListener('change', () => {
              this.handleBundleCheckboxChange(bundle, checkbox);
            });
          }
        });
      }

      // Select all button
      if (this.selectAllBtn) {
        this.selectAllBtn.addEventListener('click', () => this.handleSelectAllAccessories());
      }

      // Gift product dropdown change - updates the product/variant ID on the gift item
      this.querySelectorAll('[data-gift-product-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const giftItem = select.closest('[data-gift-item]');
          const selectedOption = select.options[select.selectedIndex];

          // Update gift item data attributes with selected product/variant ID
          if (giftItem) {
            giftItem.dataset.giftProductId = select.value;
            giftItem.dataset.giftVariantId = selectedOption.dataset.variantId;
          }

          // Update image if product has a different image
          const imageUrl = selectedOption.dataset.productImage;
          if (imageUrl) {
            const mediaEl = giftItem.querySelector('[data-gift-media] img');
            if (mediaEl) {
              mediaEl.src = imageUrl;
            }
          }

          // Update price value display if present
          const priceValue = selectedOption.dataset.productPrice;
          if (priceValue) {
            const valueEl = giftItem.querySelector('[data-gift-value]');
            if (valueEl) {
              const formattedPrice = this.formatMoney(parseInt(priceValue, 10));
              valueEl.textContent = `im Wert von ${formattedPrice}`;
            }
          }
        });
      });

      // Gift variant dropdown change - updates the variant ID on the gift item (single product with multiple variants)
      this.querySelectorAll('[data-gift-variant-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const giftItem = select.closest('[data-gift-item]');
          const selectedOption = select.options[select.selectedIndex];

          // Update gift item data attribute with selected variant ID
          if (giftItem) {
            giftItem.dataset.giftVariantId = select.value;
          }

          // Update image if variant has a different image
          const imageUrl = selectedOption.dataset.variantImage;
          if (imageUrl) {
            const mediaEl = giftItem.querySelector('[data-gift-media] img');
            if (mediaEl) {
              mediaEl.src = imageUrl;
            }
          }

          // Update price value display if present
          const priceValue = selectedOption.dataset.variantPrice;
          if (priceValue) {
            const valueEl = giftItem.querySelector('[data-gift-value]');
            if (valueEl) {
              const formattedPrice = this.formatMoney(parseInt(priceValue, 10));
              valueEl.textContent = `im Wert von ${formattedPrice}`;
            }
          }
        });
      });

      // Intercept the main product form submission
      this.interceptProductForm();
    }

    /**
     * Intercept the main product add-to-cart form to prevent adding the fake product
     * and instead add the real configured products
     */
    interceptProductForm() {
      // Find the product form (usually in the parent product info container)
      const productInfo = this.closest('.product__info-container') || this.closest('[data-section]');
      if (!productInfo) return;

      const productForm = productInfo.querySelector('product-form form, form[action="/cart/add"]');
      if (!productForm) return;

      // Intercept form submission - use capture phase to call preventDefault() BEFORE Facebook Pixel
      // This prevents navigation while still allowing the Pixel to fire its tracking event
      productForm.addEventListener('submit', (e) => {
        e.preventDefault();
        this.addToCart();
      }, true); // true = capture phase

      // Also intercept click on add-to-cart button in case it doesn't submit the form
      const addToCartBtn = productInfo.querySelector('[name="add"], [data-add-to-cart], .product-form__submit, button[type="submit"]');
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart();
        }, true); // true = capture phase
      }
    }

    handleFormSelect(btn) {
      const value = btn.dataset.optionValue;
      if (value === this.selectedForm) return;

      this.hasUserInteracted = true;
      this.selectedForm = value;

      // Update button states
      this.formButtons.forEach((b) => {
        const isSelected = b.dataset.optionValue === value;
        b.classList.toggle('is-selected', isSelected);
        b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      // Update label
      if (this.formLabel) {
        this.formLabel.textContent = value;
      }

      // Update Korbfarbe availability based on new form (hide unavailable farben)
      this.updateFarbeAvailability();
      // Update accessory visibility based on new form
      this.updateAccessoryVisibility();
      this.updateAccessoryProducts();
      // Check availability for new form selection
      this.checkKorbAvailability();
      this.updateAccessoryAvailability();
      this.updatePriceSummary();
      this.updateBanners();
      this.updateAccessoryOverlay();
      this.updateSavingsHint();
      this.updateMainProductImage();
      this.updateUrl();
    }

    handleFarbeSelect(btn, isUserAction = true) {
      const value = btn.dataset.optionValue;
      if (value === this.selectedFarbe) return;

      // Only set hasUserInteracted for actual user clicks, not programmatic calls
      if (isUserAction) {
        this.hasUserInteracted = true;
      }
      this.selectedFarbe = value;

      // Update button states
      this.farbeButtons.forEach((b) => {
        const isSelected = b.dataset.optionValue === value;
        b.classList.toggle('is-selected', isSelected);
        b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      // Update label
      if (this.farbeLabel) {
        this.farbeLabel.textContent = value;
      }

      // Update bügel availability based on new Korbfarbe
      this.updateBuegelAvailability();
      // Update accessory products based on new Korbfarbe
      this.updateAccessoryProducts();
      // Check availability for new farbe selection
      this.checkKorbAvailability();
      this.updateAccessoryAvailability();
      this.updatePriceSummary();
      this.updateAccessoryOverlay();
      this.updateMainProductImage();
      this.updateUrl();
      this.notifyUpsellSelectionChange('farbe');
    }

    /**
     * Notify Variant Discounts / accessory upsell embed about configurator state.
     * Fired on Korbfarbe (and related) changes so the app embed can refresh offers.
     */
    notifyUpsellSelectionChange(reason = 'change') {
      const detail = {
        reason,
        farbe: this.selectedFarbe || '',
        form: this.selectedForm || '',
        buegel: this.selectedBuegel || '',
        pathname: window.location.pathname,
        search: window.location.search,
        url: `${window.location.pathname}${window.location.search}`,
      };
      try {
        this.dispatchEvent(
          new CustomEvent('lk:configurator:change', {
            bubbles: true,
            composed: true,
            detail,
          }),
        );
      } catch (e) {
        /* ignore */
      }
      try {
        document.dispatchEvent(
          new CustomEvent('lk:configurator:change', { detail }),
        );
        document.dispatchEvent(
          new CustomEvent('sc-upsell:selection-change', { detail }),
        );
      } catch (e2) {
        /* ignore */
      }
    }

    handleBuegelSelect(btn, isUserAction = true, sequence = 'primary') {
      // Don't allow selection of unavailable options
      if (btn.classList.contains('is-unavailable')) return;

      const value = btn.dataset.optionValue;
      const label = btn.dataset.optionLabel || value;

      // Check which state variable to update based on sequence
      if (sequence === 'secondary') {
        // Secondary buegel selection (for Style Bundle)
        if (value === this.selectedBuegelSecondary) return;

        // Don't allow same color as primary buegel
        if (this.normalizeValue(value) === this.normalizeValue(this.selectedBuegel)) {
          return;
        }

        if (isUserAction) {
          this.hasUserInteracted = true;
        }
        this.selectedBuegelSecondary = value;

        // Update secondary button states
        this.buegelButtonsSecondary.forEach((b) => {
          const isSelected = b.dataset.optionValue === value;
          b.classList.toggle('is-selected', isSelected);
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        // Update secondary label
        if (this.buegelLabelSecondary) {
          this.buegelLabelSecondary.textContent = label;
        }
      } else {
        // Primary buegel selection
        if (value === this.selectedBuegel) return;

        if (isUserAction) {
          this.hasUserInteracted = true;
        }
        this.selectedBuegel = value;

        // Update primary button states
        this.buegelButtons.forEach((b) => {
          const isSelected = b.dataset.optionValue === value;
          b.classList.toggle('is-selected', isSelected);
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        // Update primary label
        if (this.buegelLabel) {
          this.buegelLabel.textContent = label;
        }

        // Update delivery hint for primary buegel
        if (this.buegelDeliveryHint) {
          const buegelData = this.getSelectedBuegelData('primary');
          const hint = (buegelData?.deliveryHint || '').trim();
          if (hint) {
            this.buegelDeliveryHint.textContent = `Lieferzeit: ${hint}`;
            this.buegelDeliveryHint.hidden = false;
          } else {
            this.buegelDeliveryHint.hidden = true;
          }
        }

        // If primary buegel changed, reset secondary if it's the same color
        if (this.allowSecondaryBuegel && this.normalizeValue(this.selectedBuegelSecondary) === this.normalizeValue(value)) {
          this.selectedBuegelSecondary = '';
          this.buegelButtonsSecondary.forEach((b) => {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          if (this.buegelLabelSecondary) {
            this.buegelLabelSecondary.textContent = '';
          }
        }
      }

      // Update availability to disable duplicates in secondary selector
      this.updateBuegelAvailability();
      // Update bundle group prices (they depend on Bügel price)
      this.updateBundleGroupsUI();
      // Update button state after bügel selection
      this.updateAddToCartButtonState();
      this.updatePriceSummary();
      this.updateMainProductImage();
      this.updateUrl();
    }

    handleAccessoryChange(item, checkbox) {
      this.hasUserInteracted = true;
      item.classList.toggle('is-selected', checkbox.checked);
      this.updatePriceSummary();
      this.updateBanners();
      this.updateAccessoryOverlay();
      this.updateSavingsHint();
      this.updateProductTitle();
      this.updateUrl();
    }

    /**
     * Handle bundle group checkbox change
     * Toggles all accessory items within the bundle group
     */
    handleBundleCheckboxChange(bundle, checkbox) {
      this.hasUserInteracted = true;
      const bundleGroup = bundle.dataset.bundleGroup;
      const isChecked = checkbox.checked;

      // Toggle bundle container state
      bundle.classList.toggle('is-selected', isChecked);

      // Toggle all accessory items in this bundle group
      this.accessoryItems.forEach((item) => {
        if (item.dataset.bundleGroup === bundleGroup) {
          const itemCheckbox = item.querySelector('input[type="checkbox"]');
          if (itemCheckbox) {
            itemCheckbox.checked = isChecked;
            item.classList.toggle('is-selected', isChecked);
          }
        }
      });

      this.updatePriceSummary();
      this.updateBanners();
      this.updateAccessoryOverlay();
      this.updateSavingsHint();
      this.updateProductTitle();
      this.updateUrl();
    }

    handleSelectAllAccessories() {
      this.hasUserInteracted = true;
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox && !checkbox.disabled && !checkbox.checked) {
          checkbox.checked = true;
          item.classList.add('is-selected');
        }
      });
      // Also select all bundle groups
      this.accessoryBundles?.forEach((bundle) => {
        if (bundle.hidden) return;
        const checkbox = bundle.querySelector('[data-bundle-checkbox]');
        if (checkbox && !checkbox.checked) {
          checkbox.checked = true;
          bundle.classList.add('is-selected');
        }
      });
      this.updatePriceSummary();
      this.updateBanners();
      this.updateAccessoryOverlay();
      this.updateSavingsHint();
      this.updateProductTitle();
      this.updateUrl();
    }

    /**
     * Update Korbfarbe button availability based on selected Form
     * Only show Korbfarben that have at least one produktbild with an image
     */
    updateFarbeAvailability() {
      const currentFormNorm = this.normalizeValue(this.selectedForm);

      // Get available Korbfarben for this Form (must have at least one produktbild with image)
      const availableFarben = new Set();
      if (this.produktbilder && this.produktbilder.length > 0) {
        this.produktbilder.forEach((p) => {
          if (this.normalizeValue(p.form) === currentFormNorm && p.image) {
            availableFarben.add(this.normalizeValue(p.korbFarbe));
          }
        });
      }

      // If no produktbilder data, fall back to showing all farben from korbMappings
      if (availableFarben.size === 0) {
        this.korbMappings.forEach((mapping) => {
          if (this.normalizeValue(mapping.form) === currentFormNorm) {
            availableFarben.add(this.normalizeValue(mapping.farbe));
          }
        });
      }

      // Update button states
      let selectedStillAvailable = false;
      this.farbeButtons.forEach((btn) => {
        const value = btn.dataset.optionValue;
        const valueNorm = this.normalizeValue(value);
        const isAvailable = availableFarben.has(valueNorm);

        btn.classList.toggle('is-unavailable', !isAvailable);
        btn.setAttribute('aria-disabled', !isAvailable ? 'true' : 'false');
        btn.style.display = isAvailable ? '' : 'none';

        if (isAvailable && valueNorm === this.normalizeValue(this.selectedFarbe)) {
          selectedStillAvailable = true;
        }
      });

      // If current selection is no longer available, select first available
      // Pass isUserAction=false to prevent triggering image update during initialization
      if (!selectedStillAvailable && availableFarben.size > 0) {
        for (const btn of this.farbeButtons) {
          if (!btn.classList.contains('is-unavailable')) {
            this.handleFarbeSelect(btn, false);
            break;
          }
        }
      }
    }

    /**
     * Check if the currently selected Korb (Form + Farbe) combination is available
     * Updates UI to show unavailability message but does NOT auto-switch
     * @returns {boolean} Whether the selected Korb is available
     */
    checkKorbAvailability() {
      const korbData = this.getSelectedKorbData();
      const isAvailable = korbData && korbData.available !== false;

      this.unavailableItems.korb = !isAvailable;

      // Update form button UI
      this.formButtons.forEach((btn) => {
        if (btn.dataset.optionValue === this.selectedForm) {
          btn.classList.toggle('is-unavailable-variant', !isAvailable);
        } else {
          btn.classList.remove('is-unavailable-variant');
        }
      });

      // Update farbe button UI
      this.farbeButtons.forEach((btn) => {
        if (btn.dataset.optionValue === this.selectedFarbe) {
          btn.classList.toggle('is-unavailable-variant', !isAvailable);
        } else {
          btn.classList.remove('is-unavailable-variant');
        }
      });

      // Show/hide unavailability message in korb section
      const korbSection = this.querySelector('[data-section="korb"]');
      let unavailableHint = korbSection?.querySelector('[data-korb-unavailable-hint]');

      if (!isAvailable) {
        if (!unavailableHint && korbSection) {
          unavailableHint = document.createElement('div');
          unavailableHint.className = 'bundle-configurator__unavailable-hint';
          unavailableHint.setAttribute('data-korb-unavailable-hint', '');
          unavailableHint.innerHTML =
            '<span class="bundle-configurator__unavailable-icon">!</span> Aktuell nicht verfügbar';
          korbSection.appendChild(unavailableHint);
        }
        if (unavailableHint) {
          unavailableHint.hidden = false;
        }
      } else {
        if (unavailableHint) {
          unavailableHint.hidden = true;
        }
      }

      this.updateAddToCartButtonState();
      return isAvailable;
    }

    /**
     * Update bügel button availability based on selected Korbfarbe
     * Checks both if mapping EXISTS and if the variant is AVAILABLE
     * Also handles secondary bügel availability (disables primary selection)
     */
    updateBuegelAvailability() {
      const currentFarbeNorm = this.normalizeValue(this.selectedFarbe);
      const selectedBuegelNorm = this.normalizeValue(this.selectedBuegel);
      const selectedBuegelSecondaryNorm = this.normalizeValue(this.selectedBuegelSecondary);

      // Get available bügel colors for this Korbfarbe (must exist AND be available)
      const availableBuegelColors = new Set();
      const soldOutBuegelColors = new Set(); // Exists but sold out
      this.buegelMappings.forEach((mapping) => {
        if (this.normalizeValue(mapping.korbFarbe) === currentFarbeNorm) {
          const buegelNorm = this.normalizeValue(mapping.buegelFarbe);
          if (mapping.available !== false) {
            availableBuegelColors.add(buegelNorm);
          } else {
            soldOutBuegelColors.add(buegelNorm);
          }
        }
      });

      // Update PRIMARY button states
      let selectedStillAvailable = false;
      let selectedIsSoldOut = false;
      this.buegelButtons.forEach((btn) => {
        const value = btn.dataset.optionValue;
        const valueNorm = this.normalizeValue(value);
        const exists = availableBuegelColors.has(valueNorm) || soldOutBuegelColors.has(valueNorm);
        const isAvailable = availableBuegelColors.has(valueNorm);
        const isSoldOut = soldOutBuegelColors.has(valueNorm);

        // Hide buttons that don't exist for this Korbfarbe
        btn.classList.toggle('is-unavailable', !exists);
        btn.setAttribute('aria-disabled', !exists ? 'true' : 'false');

        // Show sold-out state for existing but unavailable variants
        btn.classList.toggle('is-sold-out', isSoldOut);

        if (valueNorm === selectedBuegelNorm) {
          if (isAvailable) {
            selectedStillAvailable = true;
          } else if (isSoldOut) {
            selectedIsSoldOut = true;
          }
        }
      });

      // Track bügel unavailability state
      this.unavailableItems.buegel = selectedIsSoldOut;

      // If current selection doesn't exist, select first available
      // But do NOT auto-switch if it exists but is sold out
      // Pass isUserAction=false to prevent triggering image update during initialization
      if (!selectedStillAvailable && !selectedIsSoldOut && availableBuegelColors.size > 0) {
        for (const btn of this.buegelButtons) {
          if (!btn.classList.contains('is-unavailable') && !btn.classList.contains('is-sold-out')) {
            this.handleBuegelSelect(btn, false, 'primary');
            break;
          }
        }
      }

      // Update SECONDARY button states (if enabled)
      if (this.allowSecondaryBuegel) {
        let secondarySelectedStillAvailable = false;
        let secondarySelectedIsSoldOut = false;

        this.buegelButtonsSecondary.forEach((btn) => {
          const value = btn.dataset.optionValue;
          const valueNorm = this.normalizeValue(value);
          const exists = availableBuegelColors.has(valueNorm) || soldOutBuegelColors.has(valueNorm);
          const isAvailable = availableBuegelColors.has(valueNorm);
          const isSoldOut = soldOutBuegelColors.has(valueNorm);

          // Check if this color is already selected as primary (make it unavailable for secondary)
          const isSelectedAsPrimary = valueNorm === selectedBuegelNorm;

          // Hide buttons that don't exist OR are already selected as primary
          const isUnavailable = !exists || isSelectedAsPrimary;
          btn.classList.toggle('is-unavailable', isUnavailable);
          btn.classList.toggle('is-selected-as-primary', isSelectedAsPrimary);
          btn.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');

          // Show sold-out state for existing but unavailable variants (only if not blocked by primary)
          btn.classList.toggle('is-sold-out', isSoldOut && !isSelectedAsPrimary);

          if (valueNorm === selectedBuegelSecondaryNorm) {
            if (isAvailable && !isSelectedAsPrimary) {
              secondarySelectedStillAvailable = true;
            } else if (isSoldOut) {
              secondarySelectedIsSoldOut = true;
            }
          }
        });

        // Track secondary bügel unavailability state
        this.unavailableItems.buegelSecondary = secondarySelectedIsSoldOut;

        // If secondary selection is no longer valid (e.g., same as primary), clear it
        if (selectedBuegelSecondaryNorm && selectedBuegelSecondaryNorm === selectedBuegelNorm) {
          this.selectedBuegelSecondary = '';
          this.buegelButtonsSecondary.forEach((b) => {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          if (this.buegelLabelSecondary) {
            this.buegelLabelSecondary.textContent = '';
          }
        }
      }

      this.updateAddToCartButtonState();
    }

    /**
     * Remove loading state and reveal accessories section
     */
    revealAccessories() {
      const section = this.querySelector('[data-section="zubehoer"]');
      if (section) {
        section.classList.remove('bundle-configurator__section--loading');
      }
    }

    /**
     * Aktiviert den Read-only-Modus der Zubehör-Sektion.
     * Wird aufgerufen wenn show_zubehoer=true und allow_accessory_change=false:
     * Zubehör ist sichtbar, aber nicht anklickbar.
     */
    initReadonlyAccessories() {
      if (!this.showZubehoer || this.allowAccessoryChange) return;

      const container = this.querySelector('[data-accessories-container]');
      if (container) container.classList.add('is-readonly');

      // Alle Checkboxen deaktivieren → verhindert Interaktion
      this.accessoryItems.forEach((item) => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.disabled = true;
      });

      // Spar-Hinweis ausblenden (nicht relevant im Read-only-Modus)
      const savingsHint = this.querySelector('[data-savings-hint]');
      if (savingsHint) savingsHint.hidden = true;
    }

    updateAccessoryVisibility() {
      const currentForm = this.normalizeValue(this.selectedForm);

      // Update individual accessory items
      this.accessoryItems.forEach((item) => {
        const erlaubteFormen = item.dataset.erlaubteFormen || '';
        const checkbox = item.querySelector('input[type="checkbox"]');
        const wasHidden = item.hidden;

        // If no forms specified, show for all forms
        if (!erlaubteFormen) {
          item.hidden = false;
        } else {
          // Check if current form is in the allowed list
          const formenArray = erlaubteFormen.split(',').map((f) => this.normalizeValue(f));
          const isAllowed = formenArray.includes(currentForm);
          item.hidden = !isAllowed;
        }

        // If hiding, uncheck the checkbox
        if (item.hidden) {
          if (checkbox && !checkbox.disabled) {
            checkbox.checked = false;
            item.classList.remove('is-selected');
          }
        }
        // If showing (and was previously hidden), restore vorausgewaehlt state
        else if (wasHidden && !item.hidden) {
          const isVorausgewaehlt = item.dataset.vorausgewaehlt === 'true';
          if (checkbox && !checkbox.disabled && isVorausgewaehlt) {
            checkbox.checked = true;
            item.classList.add('is-selected');
          }
        }
      });

      // Update bundle group visibility based on erlaubte_formen
      const bundles = this.querySelectorAll('[data-accessory-bundle]');
      bundles.forEach((bundle) => {
        const erlaubteFormen = bundle.dataset.erlaubteFormen || '';
        const checkbox = bundle.querySelector('[data-bundle-checkbox]');
        const wasHidden = bundle.hidden;

        // If no forms specified, show for all forms
        if (!erlaubteFormen) {
          bundle.hidden = false;
        } else {
          // Check if current form is in the allowed list
          // Bundle shows if ANY of its items' forms match
          const formenArray = erlaubteFormen.split(',').map((f) => this.normalizeValue(f));
          const isAllowed = formenArray.includes(currentForm);
          bundle.hidden = !isAllowed;
        }

        // If hiding, uncheck the bundle checkbox and all its items
        if (bundle.hidden) {
          if (checkbox) {
            checkbox.checked = false;
            bundle.classList.remove('is-selected');
          }
          // Also uncheck all items in this bundle
          const bundleGroup = bundle.dataset.bundleGroup;
          this.accessoryItems.forEach((item) => {
            if (item.dataset.bundleGroup === bundleGroup) {
              const itemCheckbox = item.querySelector('input[type="checkbox"]');
              if (itemCheckbox) {
                itemCheckbox.checked = false;
                item.classList.remove('is-selected');
              }
            }
          });
        }
        // If showing (and was previously hidden), restore vorausgewaehlt state
        else if (wasHidden && !bundle.hidden) {
          const isVorausgewaehlt = bundle.dataset.vorausgewaehlt === 'true';
          if (checkbox && isVorausgewaehlt) {
            checkbox.checked = true;
            bundle.classList.add('is-selected');
            // Also check all items in this bundle
            const bundleGroup = bundle.dataset.bundleGroup;
            this.accessoryItems.forEach((item) => {
              if (item.dataset.bundleGroup === bundleGroup) {
                const itemCheckbox = item.querySelector('input[type="checkbox"]');
                if (itemCheckbox) {
                  itemCheckbox.checked = true;
                  item.classList.add('is-selected');
                }
              }
            });
          }
        }
      });
    }

    /**
     * Update accessory product data (image, price, variantId) based on selected Korbfarbe
     */
    updateAccessoryProducts() {
      const currentFarbeNorm = this.normalizeValue(this.selectedFarbe);
      // console.log('=== updateAccessoryProducts() ===');
      // console.log('selectedFarbe (raw):', this.selectedFarbe);
      // console.log('currentFarbeNorm:', currentFarbeNorm);
      // console.log('zubehoerMappings count:', this.zubehoerMappings?.length || 0);

      // Debug: show all available mappings with normalized keys
      if (this.zubehoerMappings) {
        // console.log('Available mappings:');
        this.zubehoerMappings.forEach((m, i) => {
          // console.log(`  [${i}] zubehoerKey="${m.zubehoerKey}" (norm: "${this.normalizeValue(m.zubehoerKey)}"), korbFarbe="${m.korbFarbe}" (norm: "${this.normalizeValue(m.korbFarbe)}"), productTitle="${m.productTitle}"`);
        });
      }

      this.accessoryItems.forEach((item) => {
        const accessoryKey = item.dataset.accessoryKey;
        const accessoryKeyNorm = this.normalizeValue(accessoryKey);
        const checkbox = item.querySelector('input[type="checkbox"]');
        const mediaEl = item.querySelector('[data-accessory-media]');
        const titleEl = item.querySelector('span[data-accessory-title]');
        const deliveryEl = item.querySelector('[data-accessory-delivery]');

        // console.log(`Looking for mapping: accessoryKey="${accessoryKey}" (norm: "${accessoryKeyNorm}"), korbFarbe="${currentFarbeNorm}"`);

        // Find matching mapping for this accessory key and Korbfarbe
        let mapping = this.zubehoerMappings.find(
          (m) =>
            this.normalizeValue(m.zubehoerKey) === accessoryKeyNorm &&
            this.normalizeValue(m.korbFarbe) === currentFarbeNorm
        );

        // console.log(`  Direct match:`, mapping ? `FOUND (${mapping.productTitle})` : 'NOT FOUND');

        // Fallback: try "all" if no specific color mapping found
        if (!mapping) {
          mapping = this.zubehoerMappings.find(
            (m) =>
              this.normalizeValue(m.zubehoerKey) === accessoryKeyNorm &&
              this.normalizeValue(m.korbFarbe) === 'all'
          );
          // console.log(`  Fallback "all" match:`, mapping ? `FOUND (${mapping.productTitle})` : 'NOT FOUND');
        }

        if (mapping) {
          // console.log(`  → Updating with productTitle: "${mapping.productTitle}"`);

          // Update checkbox data attributes
          if (checkbox) {
            checkbox.dataset.accessoryProductId = mapping.productId;
            checkbox.dataset.accessoryVariantId = mapping.variantId;
            checkbox.dataset.accessoryPrice = mapping.price;
            checkbox.dataset.accessoryTitle = mapping.productTitle;
            checkbox.dataset.accessoryDeliveryHint = (mapping.deliveryHint || '').trim();
          }

          // Update visible title text (product title from mapping)
          // console.log(`  titleEl found:`, titleEl, `tagName:`, titleEl?.tagName);
          if (titleEl && mapping.productTitle) {
            // console.log(`  Setting titleEl.textContent from "${titleEl.textContent}" to "${mapping.productTitle}"`);
            titleEl.textContent = mapping.productTitle;
          }

          // Update image
          if (mediaEl && mapping.image) {
            mediaEl.innerHTML = `<img src="${mapping.image}" alt="${this.escapeHtml(mapping.productTitle)}" loading="lazy" width="60" height="60">`;
          }

          // Update delivery hint UI
          if (deliveryEl) {
            const hint = (mapping.deliveryHint || '').trim();
            if (hint) {
              deliveryEl.textContent = `Lieferzeit: ${hint}`;
              deliveryEl.hidden = false;
            } else {
              deliveryEl.textContent = '';
              deliveryEl.hidden = true;
            }
          }

          // Update price data attribute only - actual display is handled by updateAccessorySetPrices()
          // Don't update priceEl.textContent here as it would overwrite strikethrough prices
        } else {
          // console.log(`  → NO MAPPING FOUND for accessoryKey="${accessoryKey}"`);
        }
      });

      // Update bundle group images and prices
      this.updateBundleGroupsUI();
    }

    /**
     * Update bundle group UI (images and prices) based on current Korbfarbe
     */
    updateBundleGroupsUI() {
      const bundles = this.querySelectorAll('[data-accessory-bundle]');
      
      bundles.forEach((bundle) => {
        const bundleGroup = bundle.dataset.bundleGroup;
        const bundleItems = bundle.dataset.bundleItems?.split(',') || [];
        const bundlePriceOverride = parseInt(bundle.dataset.bundlePrice || '0', 10);
        
        let totalOriginalPrice = 0;
        const bundleProductIds = [];
        
        // Update each bundle item image and collect product IDs
        bundleItems.forEach((itemKey) => {
          const imageWrapper = bundle.querySelector(`[data-bundle-item-image][data-accessory-key="${itemKey}"]`);
          const accessoryItem = this.querySelector(`[data-accessory-item][data-accessory-key="${itemKey}"]`);
          
          if (accessoryItem) {
            const checkbox = accessoryItem.querySelector('input[type="checkbox"]');
            const price = parseInt(checkbox?.dataset.accessoryPrice || '0', 10);
            const productTitle = checkbox?.dataset.accessoryTitle || '';
            const productId = checkbox?.dataset.accessoryProductId || '';
            
            totalOriginalPrice += price;
            if (productId) {
              bundleProductIds.push(parseInt(productId, 10));
            }
            
            // Find image from zubehoerMappings
            const currentFarbeNorm = this.normalizeValue(this.selectedFarbe);
            const itemKeyNorm = this.normalizeValue(itemKey);
            
            let mapping = this.zubehoerMappings.find(
              (m) =>
                this.normalizeValue(m.zubehoerKey) === itemKeyNorm &&
                this.normalizeValue(m.korbFarbe) === currentFarbeNorm
            );
            
            if (!mapping) {
              mapping = this.zubehoerMappings.find(
                (m) =>
                  this.normalizeValue(m.zubehoerKey) === itemKeyNorm &&
                  this.normalizeValue(m.korbFarbe) === 'all'
              );
            }
            
            if (imageWrapper && mapping?.image) {
              imageWrapper.innerHTML = `<img src="${mapping.image}" alt="${this.escapeHtml(mapping.productTitle || productTitle)}" loading="lazy" width="50" height="50">`;
            }
          }
        });
        
        // Calculate bundle price:
        // 1. If manual override is set, use it
        // 2. Otherwise, try to calculate from bundleConfig (function_studio)
        // 3. Fallback to sum of individual prices
        let bundlePrice = totalOriginalPrice;
        let hasDiscount = false;
        
        if (bundlePriceOverride > 0) {
          // Manual override from metafield
          bundlePrice = bundlePriceOverride;
          hasDiscount = bundlePriceOverride < totalOriginalPrice;
        } else {
          // Try to calculate from bundleConfig
          const calculatedPrice = this.calculateBundleGroupPrice(bundleProductIds, totalOriginalPrice);
          if (calculatedPrice !== null && calculatedPrice < totalOriginalPrice) {
            bundlePrice = calculatedPrice;
            hasDiscount = true;
          }
        }
        
        // Update price display
        const priceDisplay = bundle.querySelector('[data-bundle-price-display]');
        const compareDisplay = bundle.querySelector('[data-bundle-compare]');
        
        if (priceDisplay) {
          priceDisplay.textContent = this.formatMoney(bundlePrice);
        }
        
        if (compareDisplay) {
          if (hasDiscount) {
            compareDisplay.textContent = this.formatMoney(totalOriginalPrice);
            compareDisplay.classList.add('has-discount');
          } else {
            compareDisplay.textContent = '';
            compareDisplay.classList.remove('has-discount');
          }
        }
        
        // Store bundle price data for price calculations
        bundle.dataset.bundleTotalPrice = bundlePrice;
        bundle.dataset.bundleOriginalPrice = totalOriginalPrice;
      });
    }

    /**
     * Calculate the discounted price for a bundle group based on bundleConfig (function_studio)
     * 
     * Logic:
     * 1. Find a bundle rule that includes ALL the bundle group's products
     * 2. The bundle rule must contain ALL accessory products from the bundle group
     * 3. Calculate: BundleSetPrice - KorbPrice - BügelPrice = ZubehörBundlePrice
     * 
     * @param {Array} bundleProductIds - Product IDs in the accessory bundle group
     * @param {number} originalPrice - Sum of individual accessory prices
     * @returns {number|null} - Calculated bundle price in cents, or null if no matching rule
     */
    calculateBundleGroupPrice(bundleProductIds, originalPrice) {
      if (!this.bundleRules || this.bundleRules.length === 0) return null;
      if (bundleProductIds.length === 0) return null;
      
      // Get current Korb and Bügel prices
      const korbData = this.getSelectedKorbData();
      const korbPrice = korbData ? korbData.price : 0;
      const korbProductId = korbData ? parseInt(korbData.productId, 10) : 0;
      const korbVariantId = korbData ? korbData.variantId : null;
      
      const buegelData = this.getSelectedBuegelData('primary');
      const buegelPrice = buegelData ? buegelData.price : 0;
      const buegelProductId = buegelData ? parseInt(buegelData.productId, 10) : 0;
      
      // For Style Bundle with secondary bügel
      let secondaryBuegelPrice = 0;
      let secondaryBuegelProductId = 0;
      if (this.allowSecondaryBuegel && this.selectedBuegelSecondary) {
        const buegelDataSecondary = this.getSelectedBuegelData('secondary');
        secondaryBuegelPrice = buegelDataSecondary ? buegelDataSecondary.price : 0;
        secondaryBuegelProductId = buegelDataSecondary ? parseInt(buegelDataSecondary.productId, 10) : 0;
      }
      const totalBuegelPrice = buegelPrice + secondaryBuegelPrice;
      
      // Build hypothetical selected product IDs (Korb + Bügel + all bundle accessories)
      const hypotheticalProductIds = new Set();
      if (korbProductId) hypotheticalProductIds.add(korbProductId);
      if (korbVariantId) hypotheticalProductIds.add('v_' + korbVariantId);
      if (buegelProductId) hypotheticalProductIds.add(buegelProductId);
      if (secondaryBuegelProductId) hypotheticalProductIds.add(secondaryBuegelProductId);
      bundleProductIds.forEach(pid => hypotheticalProductIds.add(pid));
      
      // Collect all accessory product IDs from all bundle rules to identify accessory groups
      const accessoryGroupNames = new Set();
      for (const rule of this.bundleRules) {
        for (const component of rule.components) {
          const group = rule.groups[component.group_name];
          if (group) {
            // Check if any of our bundle products are in this group
            const hasOurProduct = bundleProductIds.some(pid => group.productIds.includes(pid));
            if (hasOurProduct) {
              accessoryGroupNames.add(component.group_name);
            }
          }
        }
      }
      
      // Find a matching bundle rule that:
      // 1. Has all components satisfied (Korb, Bügel, Accessories)
      // 2. Contains ALL our bundle group's accessory products (not just some)
      let matchingRule = null;
      let bestMatchScore = -1;
      
      for (const rule of this.bundleRules) {
        let allComponentsSatisfied = true;
        let accessoryMatchCount = 0;
        let ruleAccessoryGroupCount = 0;
        
        for (const component of rule.components) {
          const group = rule.groups[component.group_name];
          if (!group) {
            allComponentsSatisfied = false;
            break;
          }
          
          // Check if any product from this group is in our hypothetical selection
          const hasMatch = group.productIds.some(pid => hypotheticalProductIds.has(pid));
          if (!hasMatch) {
            allComponentsSatisfied = false;
            break;
          }
          
          // Count how many of our bundle products are covered by this rule
          if (accessoryGroupNames.has(component.group_name)) {
            ruleAccessoryGroupCount++;
            const matchingProducts = bundleProductIds.filter(pid => group.productIds.includes(pid));
            if (matchingProducts.length > 0) {
              accessoryMatchCount++;
            }
          }
        }
        
        // Only consider rules where ALL our bundle group accessories are covered
        // AND the rule has at least as many accessory groups as we have products
        if (allComponentsSatisfied && accessoryMatchCount >= bundleProductIds.length) {
          // Prefer rules with more accessory components (more complete bundles)
          const matchScore = ruleAccessoryGroupCount;
          if (matchScore > bestMatchScore) {
            bestMatchScore = matchScore;
            matchingRule = rule;
          }
        }
      }
      
      if (!matchingRule) return null;
      
      // Calculate: BundleSetPrice - KorbPrice - BügelPrice = ZubehörBundlePrice
      const bundleSetPrice = matchingRule.pricePerSet; // Already in cents
      const accessoryBundlePrice = bundleSetPrice - korbPrice - totalBuegelPrice;
      
      // Only return if it's actually a discount
      if (accessoryBundlePrice > 0 && accessoryBundlePrice < originalPrice) {
        return accessoryBundlePrice;
      }
      
      return null;
    }

    /**
     * Update accessory availability based on zubehoerMappings data
     * Shows sold-out accessories as disabled with strikethrough and "Ausverkauft" badge
     */
    updateAccessoryAvailability() {
      const currentFarbeNorm = this.normalizeValue(this.selectedFarbe);
      this.unavailableItems.accessories = [];

      // DEBUG: Log all zubehoerMappings
      // console.group('🔍 updateAccessoryAvailability DEBUG');
      // console.log('Selected Farbe:', this.selectedFarbe, '→ normalized:', currentFarbeNorm);
      // console.log('All zubehoerMappings:', JSON.parse(JSON.stringify(this.zubehoerMappings)));

      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;

        const accessoryKey = item.dataset.accessoryKey;
        const accessoryKeyNorm = this.normalizeValue(accessoryKey);
        const checkbox = item.querySelector('input[type="checkbox"]');
        const titleEl = item.querySelector('.bundle-configurator__accessory-title');
        const isPflicht = item.dataset.pflicht === 'true';

        // Find matching mapping
        let mapping = this.zubehoerMappings.find(
          (m) =>
            this.normalizeValue(m.zubehoerKey) === accessoryKeyNorm &&
            this.normalizeValue(m.korbFarbe) === currentFarbeNorm
        );

        // Fallback to "all" mapping
        if (!mapping) {
          mapping = this.zubehoerMappings.find(
            (m) =>
              this.normalizeValue(m.zubehoerKey) === accessoryKeyNorm &&
              this.normalizeValue(m.korbFarbe) === 'all'
          );
        }

        const isAvailable = mapping && mapping.available !== false;

        // DEBUG: Log each accessory check
        // console.log(`📦 ${accessoryKey}:`, {
        //   accessoryKeyNorm,
        //   mappingFound: !!mapping,
        //   mapping: mapping ? { zubehoerKey: mapping.zubehoerKey, korbFarbe: mapping.korbFarbe, available: mapping.available, productTitle: mapping.productTitle } : null,
        //   isAvailable,
        //   hidden: item.hidden
        // });

        // Update UI for unavailable accessories
        item.classList.toggle('is-sold-out', !isAvailable);

        // Remove or add sold-out badge
        let soldOutBadge = item.querySelector('[data-sold-out-badge]');
        if (!isAvailable) {
          if (!soldOutBadge && titleEl) {
            soldOutBadge = document.createElement('span');
            soldOutBadge.className = 'bundle-configurator__sold-out-badge';
            soldOutBadge.setAttribute('data-sold-out-badge', '');
            soldOutBadge.textContent = 'Ausverkauft';
            titleEl.parentNode?.insertBefore(soldOutBadge, titleEl.nextSibling);
          }
          if (soldOutBadge) {
            soldOutBadge.hidden = false;
          }

          // Disable checkbox for sold-out items (but not for pflicht items in bundle mode)
          if (checkbox && !isPflicht) {
            checkbox.disabled = true;
            checkbox.checked = false;
            item.classList.remove('is-selected');
          }

          // Track unavailable accessories
          this.unavailableItems.accessories.push(accessoryKey);
        } else {
          if (soldOutBadge) {
            soldOutBadge.hidden = true;
          }
          // Re-enable checkbox if it was disabled due to sold-out (but not pflicht items)
          if (checkbox && !isPflicht && !this.isBundle) {
            checkbox.disabled = false;
          }
        }
      });

      // console.log('Unavailable accessories:', this.unavailableItems.accessories);
      // console.groupEnd();

      this.updateAddToCartButtonState();
    }

    /**
     * Update accessory images overlay on product image
     * Shows selected accessories as small images with a plus icon
     */
    updateAccessoryOverlay() {
      const overlay = document.querySelector('[data-accessories-overlay]');
      const imagesContainer = document.querySelector('[data-accessories-images]');

      if (!overlay || !imagesContainer) return;

      // Collect all selected accessory images with label, benefit and price for tooltip
      const selectedImages = [];
      
      // First, collect images from selected bundle groups
      const bundles = this.querySelectorAll('[data-accessory-bundle]');
      bundles.forEach((bundle) => {
        if (bundle.hidden) return;
        const bundleCheckbox = bundle.querySelector('[data-bundle-checkbox]');
        if (!bundleCheckbox || !bundleCheckbox.checked) return;
        
        // Get images from bundle item wrappers
        const bundleImages = bundle.querySelectorAll('[data-bundle-item-image] img');
        const bundleGroup = bundle.dataset.bundleGroup;
        
        bundleImages.forEach((img) => {
          const itemKey = img.closest('[data-bundle-item-image]')?.dataset.accessoryKey;
          // Find the corresponding hidden accessory item for price/benefit data
          const accessoryItem = this.querySelector(`[data-accessory-item][data-accessory-key="${itemKey}"]`);
          const checkbox = accessoryItem?.querySelector('input[type="checkbox"]');
          
          selectedImages.push({
            src: img.src,
            alt: img.alt || 'Zubehör',
            label: img.closest('[data-bundle-item-image]')?.title || '',
            benefit: checkbox?.dataset.accessoryBenefit || '',
            price: checkbox?.dataset.accessoryPrice || '',
            isGift: false,
          });
        });
      });
      
      // Then, collect images from individual accessories (not in a bundle group)
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        
        // Skip items that belong to a bundle group (they're handled above)
        const bundleGroupName = item.dataset.bundleGroup;
        if (bundleGroupName) return;
        
        const checkbox = item.querySelector('input[type="checkbox"]');
        const mediaEl = item.querySelector('[data-accessory-media] img');
        const titleEl = item.querySelector('.bundle-configurator__accessory-title[data-label]');

        if (checkbox && checkbox.checked && mediaEl) {
          // Get label, benefit and price for tooltip
          const label = titleEl ? titleEl.getAttribute('data-label') : '';
          const benefit = checkbox.dataset.accessoryBenefit || '';
          const price = checkbox.dataset.accessoryPrice || '';

          selectedImages.push({
            src: mediaEl.src,
            alt: mediaEl.alt || checkbox.dataset.accessoryTitle || 'Zubehör',
            label: label,
            benefit: benefit,
            price: price,
            isGift: false,
          });
        }
      });

      // Also collect Gratisgeschenke (free gifts) - only if the gifts section is visible
      if (this.giftsSection && !this.giftsSection.hidden) {
        const giftItems = this.querySelectorAll('[data-gift-item]');
        giftItems.forEach((item) => {
        const mediaEl = item.querySelector('[data-gift-media] img');
        const titleEl = item.querySelector('.bundle-configurator__gift-title');
        const benefitEl = item.querySelector('.bundle-configurator__gift-benefit');
        const valueEl = item.querySelector('[data-gift-value]');

        if (mediaEl) {
          const label = titleEl ? titleEl.textContent.trim() : 'Gratisgeschenk';
          const benefit = benefitEl ? benefitEl.textContent.trim() : '';
          // Extract price from "im Wert von X €" text
          let price = '';
          if (valueEl) {
            const valueText = valueEl.textContent.trim();
            const priceMatch = valueText.match(/(\d+[,.]?\d*)\s*€/);
            if (priceMatch) {
              // Convert "12,95" to cents (1295)
              price = Math.round(parseFloat(priceMatch[1].replace(',', '.')) * 100).toString();
            }
          }

          selectedImages.push({
            src: mediaEl.src,
            alt: mediaEl.alt || label,
            label: label,
            benefit: benefit,
            price: price,
            isGift: true,
          });
        }
        });
      }

      // Show/hide overlay based on selection
      if (selectedImages.length === 0) {
        overlay.hidden = true;
        return;
      }

      overlay.hidden = false;

      // Update label text based on count
      // 1-2 items = short ("Inkl."), 3+ items = long ("Inklusive Zubehör")
      const labelEl = overlay.querySelector('.product__media-accessories-label');
      if (labelEl) {
        const useShortLabel = selectedImages.length <= 2;
        labelEl.textContent = useShortLabel ? 'Inkl.' : 'Inklusive Zubehör';
      }

      // Render images with tooltip
      imagesContainer.innerHTML = selectedImages
        .map((img, index) => {
          // Format price (price is in cents, e.g. "2495" -> "24,95 €")
          let priceFormatted = '';
          if (img.price) {
            const priceNum = parseInt(img.price, 10) / 100;
            priceFormatted = priceNum.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) + ' €';
          }

          // Build tooltip HTML: "<strong>Label</strong>im Wert von X €<br>Benefit"
          const labelHtml = `<strong>${this.escapeHtml(img.label)}</strong>`;
          const priceHtml = priceFormatted ? `im Wert von ${priceFormatted}` : '';
          const benefitHtml = img.benefit ? this.escapeHtml(img.benefit) : '';

          // Combine: Label + Price (+ Benefit if exists)
          let tooltipHtml = labelHtml;
          if (priceHtml) {
            tooltipHtml += priceHtml;
          }
          if (benefitHtml) {
            tooltipHtml += `<br><em>${benefitHtml}</em>`;
          }

          // Plain text for data-tooltip attribute (accessibility fallback)
          let tooltipText = this.escapeHtml(img.label);
          if (priceFormatted) {
            tooltipText += ' im Wert von ' + priceFormatted;
          }
          if (img.benefit) {
            tooltipText += ' – ' + this.escapeHtml(img.benefit);
          }

          return `<div class="product__media-accessories-item" style="--item-index: ${index}"
            data-tooltip="${tooltipText}"
            data-popup-label="${this.escapeHtml(img.label)}"
            data-popup-price="${priceFormatted}"
            data-popup-benefit="${this.escapeHtml(img.benefit || '')}">
            <img src="${img.src}" alt="${this.escapeHtml(img.alt)}" loading="lazy">
            <span class="product__media-accessories-tooltip">${tooltipHtml}</span>
          </div>`;
        })
        .join('');

      // Bind click events for mobile popup
      this.bindAccessoryPopupEvents();
    }

    /**
     * Bind to gallery slide change events to show/hide accessory overlay
     * Overlay should only be visible on the first slide (index 0)
     */
    bindGallerySlideEvents() {
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) return;

      // Wait for Swiper to initialize
      const checkSwiper = () => {
        if (mediaGallery.sliderInstance && mediaGallery.sliderInstance.slider) {
          const swiper = mediaGallery.sliderInstance.slider;

          // Listen for slide changes
          swiper.on('slideChange', () => {
            this.updateOverlayVisibilityForSlide(swiper.realIndex);
          });

          // Also check after initialization
          swiper.on('init', () => {
            this.updateOverlayVisibilityForSlide(swiper.realIndex);
          });

          // Initial check
          this.updateOverlayVisibilityForSlide(swiper.realIndex);
        } else {
          // Swiper not ready yet, retry
          setTimeout(checkSwiper, 100);
        }
      };

      // Start checking after a short delay to allow Swiper initialization
      setTimeout(checkSwiper, 200);
    }

    /**
     * Show/hide accessory overlay based on current slide index
     * Only show on slide 0 (first image)
     */
    updateOverlayVisibilityForSlide(slideIndex) {
      const overlay = document.querySelector('[data-accessories-overlay]');
      const viewerWrap = document.querySelector('.product__media-gallery-viewer-wrap');

      // Set data attribute on container for CSS fallback and debugging
      if (viewerWrap) {
        viewerWrap.dataset.currentSlide = slideIndex;
      }

      console.log('[BundleConfigurator] Slide changed to:', slideIndex);

      if (!overlay) return;

      // Only show overlay on first slide (index 0)
      if (slideIndex === 0) {
        // Only show if there are selected accessories (don't override hidden state)
        // The hidden attribute is controlled by updateAccessoryOverlay() based on selections
        overlay.classList.remove('is-hidden-by-slide');
      } else {
        overlay.classList.add('is-hidden-by-slide');
      }
    }

    /**
     * Bind click events on accessory items for mobile expandable overlay
     * When an item is clicked, the overlay expands and shows the item's info
     */
    bindAccessoryPopupEvents() {
      const overlay = document.querySelector('[data-accessories-overlay]');
      const closeBtn = document.querySelector('[data-accessories-close]');
      const infoTitle = document.querySelector('[data-accessories-info-title]');
      const infoPrice = document.querySelector('[data-accessories-info-price]');
      const infoBenefit = document.querySelector('[data-accessories-info-benefit]');
      const items = document.querySelectorAll('.product__media-accessories-item');

      if (!overlay) return;

      // Close button event (only bind once)
      if (closeBtn && !closeBtn.hasAttribute('data-bound')) {
        closeBtn.setAttribute('data-bound', 'true');
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.collapseAccessoryOverlay();
        }, true);
      }

      // Click on each accessory item (acts as tab)
      items.forEach((item) => {
        // Skip if already bound
        if (item.hasAttribute('data-popup-bound')) return;
        item.setAttribute('data-popup-bound', 'true');

        item.addEventListener('click', (e) => {
          // Only activate on mobile (check via media query or window width)
          if (window.innerWidth > 749) return;

          e.preventDefault();
          e.stopPropagation();

          const label = item.dataset.popupLabel || '';
          const price = item.dataset.popupPrice || '';
          const benefit = item.dataset.popupBenefit || '';

          // Update info panel content
          if (infoTitle) {
            infoTitle.textContent = label;
          }
          if (infoPrice) {
            infoPrice.textContent = price ? `im Wert von ${price}` : '';
          }
          if (infoBenefit) {
            infoBenefit.textContent = benefit;
          }

          // Remove active-tab class from all items
          items.forEach((i) => i.classList.remove('is-active-tab'));

          // Add active-tab class to clicked item
          item.classList.add('is-active-tab');

          // Expand the overlay
          overlay.classList.add('is-expanded');
        });
      });

      // Bind click-outside to close overlay
      this.bindOverlayOutsideClick();
    }

    /**
     * Collapse the mobile accessory overlay back to its compact state
     */
    collapseAccessoryOverlay() {
      const overlay = document.querySelector('[data-accessories-overlay]');
      const items = document.querySelectorAll('.product__media-accessories-item');

      if (overlay) {
        overlay.classList.remove('is-expanded');
      }

      // Remove active-tab from all items
      items.forEach((item) => item.classList.remove('is-active-tab'));
    }

    /**
     * Bind click-outside event to close expanded overlay
     */
    bindOverlayOutsideClick() {
      if (this._overlayOutsideClickBound) return;
      this._overlayOutsideClickBound = true;

      document.addEventListener('click', (e) => {
        const overlay = document.querySelector('[data-accessories-overlay]');
        if (!overlay || !overlay.classList.contains('is-expanded')) return;

        // Check if click is outside the overlay
        if (!overlay.contains(e.target)) {
          this.collapseAccessoryOverlay();
        }
      });
    }

    /**
     * Update savings hint - only shows when adding accessories would ACTUALLY reduce the total
     * This happens when a bundle discount activates that saves more than the added accessory costs
     */
    updateSavingsHint() {
      // console.log('=== updateSavingsHint() called ===');

      if (!this.savingsHint || !this.savingsHintText) {
        // console.log('Savings hint elements not found, exiting');
        return;
      }

      // Get all visible recommended accessories that are NOT currently selected
      const missingRecommended = [];
      let missingAccessoriesPrice = 0;

      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;

        const isRecommended = item.dataset.empfohlen === 'true';
        const checkbox = item.querySelector('input[type="checkbox"]');
        const titleEl = item.querySelector('.bundle-configurator__accessory-title[data-label]');

        if (isRecommended && checkbox && !checkbox.checked) {
          const label = titleEl ? titleEl.getAttribute('data-label') : '';
          const price = parseInt(checkbox.dataset.accessoryPrice || '0', 10);
          const productId = parseInt(checkbox.dataset.accessoryProductId || '0', 10);

          if (label) {
            missingRecommended.push({ label, price, productId });
            missingAccessoriesPrice += price;
          }
        }
      });

      // console.log('missingRecommended:', missingRecommended);
      // console.log('missingAccessoriesPrice:', missingAccessoriesPrice);

      // Hide hint if all recommended are selected (or none are missing)
      if (missingRecommended.length === 0) {
        // console.log('No missing recommended, hiding hint');
        this.savingsHint.hidden = true;
        return;
      }

      // Calculate CURRENT total (what user pays now)
      const currentTotal = this.calculateCurrentTotal();
      // console.log('currentTotal:', currentTotal);

      // Calculate HYPOTHETICAL total if user adds the missing accessories (with bundle discount)
      const hypotheticalTotal = this.calculateHypotheticalTotal(missingRecommended);
      // console.log('hypotheticalTotal:', hypotheticalTotal);

      // The additional cost = what the user pays more = hypothetical total - current total
      const additionalCost = hypotheticalTotal - currentTotal;
      // console.log('additionalCost:', additionalCost);

      // The real savings = what they would pay for accessories at full price - additional cost
      // This shows how much they save compared to buying accessories separately
      const actualSavings = missingAccessoriesPrice - additionalCost;
      // console.log('missingAccessoriesPrice (full price):', missingAccessoriesPrice);
      // console.log('actualSavings:', actualSavings);

      // Format the missing items with proper German grammar
      let missingText;
      if (missingRecommended.length === 1) {
        missingText = missingRecommended[0].label;
      } else if (missingRecommended.length === 2) {
        missingText = missingRecommended.map((p) => p.label).join(' und ');
      } else {
        const labels = missingRecommended.map((p) => p.label);
        const allButLast = labels.slice(0, -1).join(', ');
        const last = labels[labels.length - 1];
        missingText = allButLast + ' und ' + last;
      }

      // Format the total value of missing accessories
      const totalValueFormatted = this.formatMoney(missingAccessoriesPrice);

      // Build the hint message based on whether additionalCost is positive, zero, or negative
      // The "Hinzufügen" button is now a separate element in the HTML
      let hintHtml;

      if (additionalCost < 0) {
        // Negative cost = user saves money by ADDING the missing accessory!
        // This happens when they've added extras but not the bundle items
        const savingsFormatted = this.formatMoney(Math.abs(additionalCost));
        hintHtml = `Füge <strong>${missingText}</strong> <span class="bundle-configurator__savings-hint-value">(im Wert von ${totalValueFormatted})</span> hinzu und spare <strong>${savingsFormatted}</strong>!`;
      } else if (additionalCost === 0) {
        // Free! The bundle price already includes this
        hintHtml = `Füge <strong>${missingText}</strong> <span class="bundle-configurator__savings-hint-value">(im Wert von ${totalValueFormatted})</span> kostenlos hinzu – bereits im Set-Preis enthalten!`;
      } else {
        // Positive cost = user pays more, but potentially still saves vs. buying separately
        // Hide if additional cost equals or exceeds the value (no savings to show)
        if (additionalCost >= missingAccessoriesPrice) {
          this.savingsHint.hidden = true;
          return;
        }
        const additionalCostFormatted = this.formatMoney(additionalCost);
        hintHtml = `Für nur <strong>${additionalCostFormatted}</strong> mehr erhältst du <strong>${missingText}</strong> <span class="bundle-configurator__savings-hint-value">(im Wert von ${totalValueFormatted})</span> dazu.`;
      }

      this.savingsHintText.innerHTML = hintHtml;
      this.savingsHint.hidden = false;

      // Bind click event to the "Hinzufügen" button (only once)
      this.bindAddMissingAccessoriesButton();
    }

    /**
     * Bind click event to "Hinzufügen" button in savings hint
     * Called once during initialization
     */
    bindAddMissingAccessoriesButton() {
      const btn = this.savingsHint?.querySelector('[data-add-missing-accessories]');
      if (!btn || btn.dataset.bound) return;

      btn.addEventListener('click', () => {
        this.addMissingRecommendedAccessories();
      });
      btn.dataset.bound = 'true';
    }

    /**
     * Add all missing recommended accessories (check them)
     */
    addMissingRecommendedAccessories() {
      this.hasUserInteracted = true;
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;

        const isRecommended = item.dataset.empfohlen === 'true';
        const checkbox = item.querySelector('input[type="checkbox"]');

        if (isRecommended && checkbox && !checkbox.checked && !checkbox.disabled) {
          checkbox.checked = true;
          item.classList.add('is-selected');
        }
      });

      // Update all displays
      this.updatePriceSummary();
      this.updateBanners();
      this.updateAccessoryOverlay();
      this.updateSavingsHint();
      this.updateProductTitle();
      this.updateUrl();
    }

    /**
     * Calculate the current total price based on current selection
     */
    calculateCurrentTotal() {
      const korbData = this.getSelectedKorbData();
      const korbPrice = korbData ? korbData.price : 0;

      // Get primary bügel price
      const buegelData = this.getSelectedBuegelData('primary');
      const buegelPrice = buegelData ? buegelData.price : 0;

      // Get secondary bügel price (if enabled, for Style Bundle)
      let secondaryBuegelPrice = 0;
      if (this.allowSecondaryBuegel && this.selectedBuegelSecondary) {
        const buegelDataSecondary = this.getSelectedBuegelData('secondary');
        secondaryBuegelPrice = buegelDataSecondary ? buegelDataSecondary.price : 0;
      }
      const totalBuegelPrice = buegelPrice + secondaryBuegelPrice;

      let accessoriesPrice = 0;
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (!checkbox || !checkbox.checked) return;
        
        // Check if this item belongs to a bundle group
        const bundleGroupName = item.dataset.bundleGroup;
        if (bundleGroupName) {
          const parentBundle = this.querySelector(`[data-accessory-bundle][data-bundle-group="${bundleGroupName}"]`);
          if (parentBundle) {
            const bundleCheckbox = parentBundle.querySelector('[data-bundle-checkbox]');
            if (!bundleCheckbox || !bundleCheckbox.checked) {
              return; // Skip if bundle is not checked
            }
          }
        }
        
        accessoriesPrice += parseInt(checkbox.dataset.accessoryPrice || 0, 10);
      });

      // Include both bügel prices for Style Bundle
      const subtotal = korbPrice + totalBuegelPrice + accessoriesPrice;

      // Check for bundle discount
      const matchingRule = this.getMatchingBundleRule();
      if (matchingRule) {
        // Calculate bundle price - only include products from the bundle's components
        const bundleProductIds = new Set();
        matchingRule.components.forEach((component) => {
          const group = matchingRule.groups[component.group_name];
          if (group) {
            group.productIds.forEach((pid) => bundleProductIds.add(pid));
          }
        });

        let bundleAccessoriesPrice = 0;
        let extraAccessoriesPrice = 0;
        this.accessoryItems.forEach((item) => {
          if (item.hidden) return;
          const checkbox = item.querySelector('input[type="checkbox"]');
          if (!checkbox || !checkbox.checked) return;
          
          // Check if this item belongs to a bundle group
          const bundleGroupName = item.dataset.bundleGroup;
          if (bundleGroupName) {
            const parentBundle = this.querySelector(`[data-accessory-bundle][data-bundle-group="${bundleGroupName}"]`);
            if (parentBundle) {
              const bundleCheckbox = parentBundle.querySelector('[data-bundle-checkbox]');
              if (!bundleCheckbox || !bundleCheckbox.checked) {
                return; // Skip if bundle is not checked
              }
            }
          }
          
          const price = parseInt(checkbox.dataset.accessoryPrice || 0, 10);
          const productId = parseInt(checkbox.dataset.accessoryProductId || 0, 10);
          if (bundleProductIds.has(productId)) {
            bundleAccessoriesPrice += price;
          } else {
            extraAccessoriesPrice += price;
          }
        });

        // Check if Bügel is in the bundle's components
        const buegelInBundle = matchingRule.components.some((component) => {
          const group = matchingRule.groups[component.group_name];
          return group && (group.name.includes('Bügelset') || group.name.includes('Bügel'));
        });
        // For Style Bundle with 2 bügel, totalBuegelPrice includes both
        const bundleComponentsPrice = buegelInBundle
          ? korbPrice + totalBuegelPrice + bundleAccessoriesPrice
          : korbPrice + bundleAccessoriesPrice;

        if (bundleComponentsPrice > matchingRule.pricePerSet) {
          let total = matchingRule.pricePerSet + extraAccessoriesPrice;
          if (!buegelInBundle) {
            total += totalBuegelPrice;
          }
          return total;
        }
      }

      // Fallback: percentage discount
      if (this.config.setRabattProzent > 0 && this.areAllCompatibleAccessoriesSelected()) {
        const discount = Math.round(subtotal * (this.config.setRabattProzent / 100));
        return subtotal - discount;
      }

      return subtotal;
    }

    /**
     * Calculate hypothetical total if user adds the missing recommended accessories
     * This simulates adding the missing accessories and calculates the price with bundle discount
     */
    calculateHypotheticalTotal(missingAccessories) {
      // console.log('=== calculateHypotheticalTotal() ===');
      // console.log('missingAccessories:', missingAccessories);
      const korbData = this.getSelectedKorbData();
      const korbPrice = korbData ? korbData.price : 0;

      // Get primary bügel price
      const buegelData = this.getSelectedBuegelData('primary');
      const buegelPrice = buegelData ? buegelData.price : 0;

      // Get secondary bügel price (if enabled, for Style Bundle)
      let secondaryBuegelPrice = 0;
      if (this.allowSecondaryBuegel && this.selectedBuegelSecondary) {
        const buegelDataSecondary = this.getSelectedBuegelData('secondary');
        secondaryBuegelPrice = buegelDataSecondary ? buegelDataSecondary.price : 0;
      }
      const totalBuegelPrice = buegelPrice + secondaryBuegelPrice;

      // Current accessories + missing accessories
      let totalAccessoriesPrice = 0;
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          totalAccessoriesPrice += parseInt(checkbox.dataset.accessoryPrice || 0, 10);
        }
      });

      // Add missing accessories
      missingAccessories.forEach((acc) => {
        totalAccessoriesPrice += acc.price;
      });

      // Include both bügel prices for Style Bundle
      const subtotal = korbPrice + totalBuegelPrice + totalAccessoriesPrice;
      // console.log('korbPrice:', korbPrice, 'totalBuegelPrice:', totalBuegelPrice, 'totalAccessoriesPrice:', totalAccessoriesPrice);
      // console.log('subtotal:', subtotal);

      // Check for bundle discount rule using HYPOTHETICAL product IDs
      // (including the missing accessories that we're simulating as selected)
      const matchingRule = this.getMatchingBundleRuleHypothetical(missingAccessories);
      // console.log('matchingRule (hypothetical):', matchingRule ? matchingRule.message : 'NULL');

      if (matchingRule) {
        // Calculate bundle price - only include products from the bundle's components
        const bundleProductIds = new Set();
        matchingRule.components.forEach((component) => {
          const group = matchingRule.groups[component.group_name];
          if (group) {
            group.productIds.forEach((pid) => bundleProductIds.add(pid));
          }
        });
        // console.log('bundleProductIds:', [...bundleProductIds]);

        let bundleAccessoriesPrice = 0;
        let extraAccessoriesPrice = 0;

        // Current selected accessories
        this.accessoryItems.forEach((item) => {
          if (item.hidden) return;
          const checkbox = item.querySelector('input[type="checkbox"]');
          if (checkbox && checkbox.checked) {
            const price = parseInt(checkbox.dataset.accessoryPrice || 0, 10);
            const productId = parseInt(checkbox.dataset.accessoryProductId || 0, 10);
            // console.log('  Accessory:', checkbox.dataset.accessoryKey, 'productId:', productId, 'inBundle:', bundleProductIds.has(productId));
            if (bundleProductIds.has(productId)) {
              bundleAccessoriesPrice += price;
            } else {
              extraAccessoriesPrice += price;
            }
          }
        });

        // Add missing accessories - check if they're part of bundle using their productId
        missingAccessories.forEach((acc) => {
          const accProductId = acc.productId || 0;
          // console.log('  Missing acc:', acc.label, 'productId:', accProductId, 'inBundle:', bundleProductIds.has(accProductId));

          if (bundleProductIds.has(accProductId)) {
            bundleAccessoriesPrice += acc.price;
          } else {
            extraAccessoriesPrice += acc.price;
          }
        });
        // console.log('bundleAccessoriesPrice:', bundleAccessoriesPrice, 'extraAccessoriesPrice:', extraAccessoriesPrice);

        // Check if Bügel is in the bundle's components
        const buegelInBundle = matchingRule.components.some((component) => {
          const group = matchingRule.groups[component.group_name];
          return group && (group.name.includes('Bügelset') || group.name.includes('Bügel'));
        });
        // For Style Bundle with 2 bügel, totalBuegelPrice includes both
        const bundleComponentsPrice = buegelInBundle
          ? korbPrice + totalBuegelPrice + bundleAccessoriesPrice
          : korbPrice + bundleAccessoriesPrice;
        // console.log('buegelInBundle:', buegelInBundle, 'bundleComponentsPrice:', bundleComponentsPrice, 'pricePerSet:', matchingRule.pricePerSet);

        if (bundleComponentsPrice > matchingRule.pricePerSet) {
          let total = matchingRule.pricePerSet + extraAccessoriesPrice;
          if (!buegelInBundle) {
            total += totalBuegelPrice;
          }
          // console.log('Bundle discount applied, returning:', total);
          return total;
        }
      }

      // Fallback: percentage discount
      // console.log('this.config.setRabattProzent:', this.config.setRabattProzent);
      if (this.config.setRabattProzent > 0) {
        const discount = Math.round(subtotal * (this.config.setRabattProzent / 100));
        // console.log('Percentage discount applied:', discount, '| returning:', subtotal - discount);
        return subtotal - discount;
      }

      // console.log('No discount, returning subtotal:', subtotal);
      return subtotal;
    }

    /**
     * ═══════════════════════════════════════════════════════════════════════════════════
     * UPDATE PRICE SUMMARY - Hauptmethode für die Preisberechnung und UI-Aktualisierung
     * ═══════════════════════════════════════════════════════════════════════════════════
     *
     * Diese Methode ist das Herzstück der Preisberechnung. Sie wird bei jeder Änderung
     * der Auswahl aufgerufen (Korb, Farbe, Bügel, Zubehör).
     *
     * PREISBERECHNUNGS-LOGIK:
     * ───────────────────────
     * 1. Einzelpreise sammeln: Korb + Bügel + Zubehör = Subtotal
     *
     * 2. Bundle-Regel prüfen (getMatchingBundleRule):
     *    - Wenn eine Bundle-Regel matched → Fixed-Price Bundle (z.B. 249€)
     *    - Zubehör wird in "bundle-included" und "extra" aufgeteilt
     *
     * 3. Rabatt berechnen:
     *    - BUNDLE-RABATT: bundleComponentsPrice - pricePerSet = discount
     *    - PROZENT-RABATT (Fallback): subtotal × setRabattProzent
     *
     * BEISPIEL:
     * ─────────
     * Korb (139€) + Bügel (29€) + Deckel (49€) + Einlegeboden (39€) = 256€ Subtotal
     * Bundle "Komplett-Set" matched → pricePerSet = 249€
     * → discount = 256€ - 249€ = 7€
     * → total = 249€
     *
     * EXTRA-ZUBEHÖR (nicht im Bundle):
     * ────────────────────────────────
     * Wenn Zubehör NICHT Teil des Bundle ist, wird es zum Bundle-Preis addiert:
     * Bundle (249€) + Extra-Zubehör (z.B. Tasche 39€) = 288€
     *
     * UI-UPDATES:
     * ───────────
     * - summaryLieblingskorb: Korb + Bügel Preis
     * - summaryAccessories: Zubehör-Preis
     * - summaryDiscount: Rabatt (wenn vorhanden)
     * - summaryTotal: Endpreis
     * - summaryCompare: Durchgestrichener Originalpreis
     * - savingsText: "Du sparst X€" Banner
     * - Sticky Cart (Mobile)
     * - Einzelne Zubehör-Preise (mit anteiligem Rabatt)
     */
    updatePriceSummary() {
      // console.log('=== updatePriceSummary() called ===');
      // console.trace('updatePriceSummary stack trace');

      // Get korb price
      const korbData = this.getSelectedKorbData();
      const korbPrice = korbData ? korbData.price : 0;

      // Get bügel price (primary)
      const buegelData = this.getSelectedBuegelData('primary');
      const buegelPrice = buegelData ? buegelData.price : 0;

      // Get secondary bügel price (if enabled, for Style Bundle)
      let secondaryBuegelPrice = 0;
      if (this.allowSecondaryBuegel && this.selectedBuegelSecondary) {
        const buegelDataSecondary = this.getSelectedBuegelData('secondary');
        secondaryBuegelPrice = buegelDataSecondary ? buegelDataSecondary.price : 0;
      }
      const totalBuegelPrice = buegelPrice + secondaryBuegelPrice;

      // Try to get matching bundle rule first to separate bundle vs non-bundle accessories
      const matchingRule = this.getMatchingBundleRule();
      // Store matched rule message for use at add-to-cart time
      this.dataset.bundleMatchedMessage = matchingRule?.name || '';
      // console.log('=== updatePriceSummary ===');
      // console.log('matchingRule:', matchingRule ? matchingRule.message : 'NULL', '| pricePerSet:', matchingRule?.pricePerSet);

      // Collect ONLY the product IDs that are part of the MATCHED bundle's components
      // (not ALL groups, only the groups that are in this bundle's components)
      const bundleProductIds = new Set();
      if (matchingRule) {
        // Only include products from groups that are in the bundle's components
        matchingRule.components.forEach((component) => {
          const group = matchingRule.groups[component.group_name];
          if (group) {
            group.productIds.forEach((pid) => bundleProductIds.add(pid));
          }
        });
      }
      // console.log('bundleProductIds (from matched rule):', [...bundleProductIds]);

      // Separate accessories into bundle-included and extra (non-bundle)
      let bundleAccessoriesPrice = 0;
      let extraAccessoriesPrice = 0;
      let accessoriesCount = 0;
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          const price = parseInt(checkbox.dataset.accessoryPrice || 0, 10);
          const productId = parseInt(checkbox.dataset.accessoryProductId || 0, 10);
          accessoriesCount++;

          // console.log('Accessory:', checkbox.dataset.accessoryKey, 'productId:', productId, 'inBundle:', bundleProductIds.has(productId));

          // Check if this accessory is part of the bundle
          if (matchingRule && bundleProductIds.has(productId)) {
            bundleAccessoriesPrice += price;
          } else {
            // This is an extra accessory not included in the bundle
            extraAccessoriesPrice += price;
          }
        }
      });

      const totalAccessoriesPrice = bundleAccessoriesPrice + extraAccessoriesPrice;
      // console.log('bundleAccessoriesPrice:', bundleAccessoriesPrice, 'extraAccessoriesPrice:', extraAccessoriesPrice);

      // Calculate total value of Gratisgeschenke (free gifts)
      // These are added to the UVP/subtotal to show their value, increasing the displayed savings
      // Only include gifts if all accessories are selected (gifts are conditional)
      const giftItems = this.querySelectorAll('[data-gift-item]');
      let giftsValue = 0;
      if (this.areGiftsIncluded()) {
        giftItems.forEach((item) => {
          const valueEl = item.querySelector('[data-gift-value]');
          if (valueEl) {
            // Extract price from "im Wert von X €" text or from data attribute
            const valueText = valueEl.textContent.trim();
            const priceMatch = valueText.match(/(\d+[,.]?\d*)\s*€/);
            if (priceMatch) {
              // Convert "12,95" to cents (1295)
              giftsValue += Math.round(parseFloat(priceMatch[1].replace(',', '.')) * 100);
            }
          }
        });
      }
      // console.log('giftsValue:', giftsValue);

      // Calculate totals (including both bügel prices for Style Bundle)
      // Subtotal includes gift values to show their contribution to UVP
      const subtotal = korbPrice + totalBuegelPrice + totalAccessoriesPrice + giftsValue;
      let discount = 0;
      let total = subtotal;
      let bundleApplied = false;

      // Check if this is a Fixed Price Bundle
      // Fixed Price = no discount on products, only gifts are "savings"
      const isFixedPrice = this.config.isFixedPrice === true;

      if (!isFixedPrice && matchingRule && matchingRule.pricingMode && matchingRule.pricePerSet > 0) {
        // Check if Bügel is included in the bundle's components (not all groups)
        const buegelInBundle = matchingRule.components.some((component) => {
          const group = matchingRule.groups[component.group_name];
          return group && (group.name.includes('Bügelset') || group.name.includes('Bügel'));
        });

        // Bundle components price - only includes items that are part of the bundle
        // For Style Bundle with 2 bügel, totalBuegelPrice includes both
        const bundleComponentsPrice = buegelInBundle
          ? korbPrice + totalBuegelPrice + bundleAccessoriesPrice
          : korbPrice + bundleAccessoriesPrice;

        // console.log('bundleComponentsPrice:', bundleComponentsPrice, 'pricePerSet:', matchingRule.pricePerSet, 'buegelInBundle:', buegelInBundle);

        if (bundleComponentsPrice > matchingRule.pricePerSet) {
          discount = bundleComponentsPrice - matchingRule.pricePerSet;
          // Bundle price + extra accessories (not part of bundle) + bügel if not in bundle
          total = matchingRule.pricePerSet + extraAccessoriesPrice;
          if (!buegelInBundle) {
            total += buegelPrice;
          }
          bundleApplied = true;
          // console.log('BUNDLE APPLIED! discount:', discount, 'total:', total);
        }
      }

      // Fallback: Apply percentage discount if no bundle rule matched (and not fixed price)
      if (!isFixedPrice && !bundleApplied && this.config.setRabattProzent > 0 && this.areAllCompatibleAccessoriesSelected()) {
        // For percentage discount, calculate on base price (without gifts)
        const baseSubtotal = korbPrice + totalBuegelPrice + totalAccessoriesPrice;
        discount = Math.round(baseSubtotal * (this.config.setRabattProzent / 100));
        total = baseSubtotal - discount;
        // console.log('Percentage discount applied:', discount, 'total:', total);
      }

      // For Fixed Price Bundle: total = product prices, savings = only gift values
      if (isFixedPrice) {
        // No discount on products - total is just the sum of products (without gifts)
        total = korbPrice + totalBuegelPrice + totalAccessoriesPrice;
        // Savings come only from the free gifts
        discount = giftsValue;
      } else {
        // Add gifts value to discount (gifts are free, so their value is "saved")
        // This makes the savings display include the gift value
        if (giftsValue > 0) {
          discount += giftsValue;
        }
      }

      // console.log('FINAL: subtotal:', subtotal, 'discount:', discount, 'total:', total, 'giftsValue:', giftsValue);

      // Update summary display
      if (this.summaryLieblingskorb) {
        this.summaryLieblingskorb.textContent = this.formatMoney(korbPrice + buegelPrice);
      }
      if (this.summaryAccessories) {
        this.summaryAccessories.textContent =
          accessoriesCount > 0 ? this.formatMoney(totalAccessoriesPrice) : '-';
      }
      if (this.accessoriesRow) {
        this.accessoriesRow.hidden = accessoriesCount === 0;
      }
      // console.log('discount:', discount, '| total:', total, '| subtotal:', subtotal);
      // console.log('accessoriesCount:', accessoriesCount, '| bundleAccessoriesPrice:', bundleAccessoriesPrice);

      if (this.discountRow) {
        this.discountRow.hidden = discount <= 0;
        // console.log('discountRow.hidden:', this.discountRow.hidden);
      }
      if (this.summaryDiscount) {
        this.summaryDiscount.textContent = discount > 0 ? this.formatMoney(discount) : '';
      }
      if (this.summaryTotal) {
        this.summaryTotal.textContent = this.formatMoney(total);
      }
      if (this.summaryCompare) {
        if (discount > 0) {
          this.summaryCompare.textContent = this.formatMoney(subtotal);
          this.summaryCompare.hidden = false;
        } else {
          this.summaryCompare.hidden = true;
        }
      }

      // Update sublabel (LIEBLINGSKORB + x Zubehör + x Bügelsets)
      if (this.summarySublabel) {
        const buegelsetCount = (this.allowSecondaryBuegel && this.selectedBuegel && this.selectedBuegelSecondary) ? 2 : 1;
        const parts = ['LIEBLINGSKORB'];
        if (accessoriesCount > 0) {
          parts.push(`${accessoriesCount} Zubehör`);
        }
        if (buegelsetCount > 1) {
          parts.push(`${buegelsetCount} Bügelsets`);
        }
        this.summarySublabel.textContent = `(${parts.join(' + ')})`;
        this.summarySublabel.hidden = false;
      }

      // Update savings text in success banner
      if (this.savingsText) {
        if (discount > 0) {
          this.savingsText.textContent = `Du sparst ${this.formatMoney(discount)}`;
        } else {
          this.savingsText.textContent = '';
        }
      }

      // Update main product price display on the page
      this.updateMainPrice(total, subtotal, discount);

      // Count gift items (only when gifts are included)
      const giftsCount = this.areGiftsIncluded() ? giftItems.length : 0;

      // Update mobile sticky cart
      this.updateStickyCart(total, subtotal, discount, accessoriesCount, giftsCount);

      // Update accessory set prices (strikethrough + discounted price)
      // We need bundleComponentsPrice for correct proportional calculation
      // Check only the bundle's components (not all groups)
      const buegelInBundle = matchingRule && matchingRule.components.some((component) => {
        const group = matchingRule.groups[component.group_name];
        return group && (group.name.includes('Bügelset') || group.name.includes('Bügel'));
      });
      const bundleComponentsPrice = matchingRule
        ? (buegelInBundle ? korbPrice + buegelPrice + bundleAccessoriesPrice : korbPrice + bundleAccessoriesPrice)
        : 0;
      this.updateAccessorySetPrices(discount, bundleProductIds, bundleAccessoriesPrice, totalAccessoriesPrice, bundleComponentsPrice);
    }

    /**
     * Update accessory prices to show original price (strikethrough) and discounted set price
     * @param {number} totalDiscount - Total discount amount in cents
     * @param {Set} bundleProductIds - Set of product IDs that are part of the bundle
     * @param {number} bundleAccessoriesPrice - Total price of bundle accessories in the bundle
     * @param {number} totalAccessoriesPrice - Total price of all selected accessories
     * @param {number} bundleComponentsPrice - Total price of all bundle components (korb + bügel + accessories)
     */
    updateAccessorySetPrices(totalDiscount, bundleProductIds, bundleAccessoriesPrice, totalAccessoriesPrice, bundleComponentsPrice) {
      const currentFarbeNorm = this.normalizeValue(this.selectedFarbe);

      // Update individual accessory prices
      // Show strikethrough price if the item has a saleprice set in the metaobject
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;

        const compareEl = item.querySelector('[data-accessory-compare]');
        // Select the span element specifically (not the input which also has data-accessory-price)
        const priceEl = item.querySelector('span[data-accessory-price]');

        if (!priceEl) return;

        const checkbox = item.querySelector('input[type="checkbox"]');
        let originalPrice = parseInt(checkbox?.dataset.accessoryPrice || 0, 10);

        // Fallback: If price is not set on checkbox, try to find it directly from mappings
        if (originalPrice === 0 && checkbox) {
          const accessoryKey = item.dataset.accessoryKey;
          const accessoryKeyNorm = this.normalizeValue(accessoryKey);

          let mapping = this.zubehoerMappings.find(
            (m) =>
              this.normalizeValue(m.zubehoerKey) === accessoryKeyNorm &&
              this.normalizeValue(m.korbFarbe) === currentFarbeNorm
          );

          // Fallback: try "all" if no specific color mapping found
          if (!mapping) {
            mapping = this.zubehoerMappings.find(
              (m) =>
                this.normalizeValue(m.zubehoerKey) === accessoryKeyNorm &&
                this.normalizeValue(m.korbFarbe) === 'all'
            );
          }

          if (mapping && mapping.price) {
            originalPrice = parseInt(mapping.price, 10);
            // Also update the checkbox dataset for consistency
            checkbox.dataset.accessoryPrice = mapping.price;
          }
        }

        // Check if this item has a sale price set (from metaobject)
        const salePriceStr = item.dataset.salePrice;
        const hasSalePrice = salePriceStr && salePriceStr !== '';
        
        if (hasSalePrice && compareEl) {
          // Sale price is in Euro (e.g. "47.48"), convert to cents
          const salePrice = Math.round(parseFloat(salePriceStr) * 100);
          
          // Only show strikethrough if sale price is less than original price
          if (salePrice > 0 && salePrice < originalPrice) {
            // Show original price as strikethrough
            compareEl.textContent = this.formatMoney(originalPrice);
            compareEl.hidden = false;
            item.classList.add('has-sale');
            
            // Show sale price as current price
            priceEl.textContent = this.formatMoney(salePrice);
          } else {
            // Invalid sale price, show original
            compareEl.hidden = true;
            item.classList.remove('has-sale');
            priceEl.textContent = originalPrice > 0 ? this.formatMoney(originalPrice) : '-';
          }
        } else {
          // No sale price, show original price only
          if (compareEl) {
            compareEl.hidden = true;
          }
          item.classList.remove('has-sale');
          priceEl.textContent = originalPrice > 0 ? this.formatMoney(originalPrice) : '-';
        }
      });
    }

    /**
     * ═══════════════════════════════════════════════════════════════════════════════════
     * UPDATE MAIN PRODUCT IMAGE - Aktualisiert die Produktgalerie basierend auf Auswahl
     * ═══════════════════════════════════════════════════════════════════════════════════
     *
     * Diese Methode tauscht die gesamte Bildgalerie aus, wenn der Benutzer eine andere
     * Kombination aus Form, Farbe und Bügelfarbe auswählt.
     *
     * WARUM WIRD DIE GALERIE AUSGETAUSCHT?
     * ────────────────────────────────────
     * Jede Kombination (z.B. "Classic + Weiß + Gold") hat ein eigenes Produkt in Shopify
     * mit eigenen Produktfotos. Bei Auswahländerung werden die Bilder des entsprechenden
     * Produkts geladen und angezeigt.
     *
     * DATENQUELLE: produktbilder Array (aus Metafield)
     * ─────────────────────────────────────────────────
     * this.produktbilder = [
     *   { form: "Classic", korbFarbe: "Weiß", buegelFarbe: "gold", productHandle: "klassik-weiss-gold", ... },
     *   { form: "Classic", korbFarbe: "Weiß", buegelFarbe: "silber", productHandle: "klassik-weiss-silber", ... },
     *   { form: "Edge", korbFarbe: "Anthrazit", buegelFarbe: "gold", productHandle: "edge-anthrazit-gold", ... },
     *   ...
     * ]
     *
     * BILD-LADEMETHODEN (Priorität):
     * ──────────────────────────────
     * 1. productHandle → fetchAndReplaceGalleryImages() lädt alle Bilder via Shopify JSON API
     * 2. images Array → replaceAllGalleryImages() verwendet vorhandene Bild-URLs
     * 3. image (einzeln) → updateFirstImageOnly() tauscht nur das erste Bild (Legacy)
     *
     * WICHTIG - hasUserInteracted Flag:
     * ──────────────────────────────────
     * Die Methode überspringt Updates wenn hasUserInteracted=false, um zu verhindern,
     * dass beim Seitenaufruf mit URL-Parametern sofort alle Bilder neu geladen werden.
     * Erst wenn der Benutzer aktiv eine Auswahl ändert, werden die Bilder aktualisiert.
     *
     * @param {boolean} forceUpdate - Wenn true, wird hasUserInteracted ignoriert (für popstate/Navigation)
     */
    updateMainProductImage(forceUpdate = false) {
      // console.log('=== updateMainProductImage() CALLED ===');
      // console.log('  forceUpdate:', forceUpdate);
      // console.log('  hasUserInteracted:', this.hasUserInteracted);
      // console.log('  Stack trace:', new Error().stack);

      // Only update images when user actively changes Form/Farbe/Bügel
      // Skip on: initial page load (with or without URL params), accessory changes
      // Allow on: forceUpdate=true (for popstate/browser navigation)
      if (!forceUpdate && !this.hasUserInteracted) {
        // console.log('=== updateMainProductImage() SKIPPED (no user interaction yet) ===');
        return;
      }

      // console.log('=== updateMainProductImage() PROCEEDING ===');

      // Log produktbilder data
      // console.log('produktbilder array:', this.produktbilder);
      // console.log('produktbilder length:', this.produktbilder ? this.produktbilder.length : 'undefined');

      if (!this.produktbilder || this.produktbilder.length === 0) {
        // console.log('❌ ABORT: produktbilder is empty or undefined');
        return;
      }

      // Normalize values for comparison (handle case variations)
      const normalizeValue = (value) => {
        if (!value) return '';
        return value.toLowerCase().trim();
      };

      // Log current selection values
      // console.log('Current selection (raw):');
      // console.log('  - selectedForm:', this.selectedForm);
      // console.log('  - selectedFarbe:', this.selectedFarbe);
      // console.log('  - selectedBuegel:', this.selectedBuegel);

      // Find matching produktbild for current selection
      const selectedFormNorm = normalizeValue(this.selectedForm);
      const selectedFarbeNorm = normalizeValue(this.selectedFarbe);
      const selectedBuegelNorm = normalizeValue(this.selectedBuegel);

      // console.log('Current selection (normalized):');
      // console.log('  - selectedFormNorm:', selectedFormNorm);
      // console.log('  - selectedFarbeNorm:', selectedFarbeNorm);
      // console.log('  - selectedBuegelNorm:', selectedBuegelNorm);

      // Log all produktbilder entries for comparison
      // console.log('All produktbilder entries:');
      this.produktbilder.forEach((p, i) => {
        // console.log(`  [${i}] form="${p.form}", korbFarbe="${p.korbFarbe}", buegelFarbe="${p.buegelFarbe}", image="${p.image ? 'YES' : 'NO'}"`);
      });

      const matching = this.produktbilder.find((p) => {
        const formNorm = normalizeValue(p.form);
        const korbFarbeNorm = normalizeValue(p.korbFarbe);
        const buegelFarbeNorm = normalizeValue(p.buegelFarbe);

        const isMatch = (
          formNorm === selectedFormNorm &&
          korbFarbeNorm === selectedFarbeNorm &&
          buegelFarbeNorm === selectedBuegelNorm
        );

        if (isMatch) {
          // console.log(`  ✅ MATCH found: form="${formNorm}", korbFarbe="${korbFarbeNorm}", buegelFarbe="${buegelFarbeNorm}"`);
        }

        return isMatch;
      });

      // console.log('Matching result:', matching);

      if (!matching) {
        // console.log('❌ ABORT: No matching produktbild found');
        return;
      }

      // Find the media gallery
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        // console.log('❌ ABORT: media-gallery element not found');
        return;
      }

      // console.log('Matching entry:', {
      //   productHandle: matching.productHandle,
      //   images: matching.images,
      //   image: matching.image
      // });

      // If we have a product handle, fetch all images from the product JSON API
      if (matching.productHandle) {
        // console.log('→ Using productHandle to fetch images:', matching.productHandle);
        this.fetchAndReplaceGalleryImages(mediaGallery, matching.productHandle);
      } else if (matching.images && Array.isArray(matching.images) && matching.images.length > 0) {
        // console.log('→ Using images array from metafield');
        // Fallback: Use images array from metafield (if available)
        this.replaceAllGalleryImages(mediaGallery, matching.images);
      } else if (matching.image) {
        // console.log('→ Using single image (backwards compatibility)');
        // Fallback: Only update first image (backwards compatibility)
        this.updateFirstImageOnly(mediaGallery, matching.image);
      } else {
        // console.log('❌ No image data found in matching entry');
        return;
      }

      // Update the product title
      this.updateProductTitle();
    }

    /**
     * Lädt alle Produktbilder über die Shopify JSON API und ersetzt die Galerie.
     *
     * API-ENDPOINT: /products/{productHandle}.json
     * ─────────────────────────────────────────────
     * Gibt das vollständige Produkt-Objekt zurück, inkl. aller Bilder mit
     * Dimensionen (width/height) für korrekte Aspect-Ratio-Berechnung.
     *
     * @param {HTMLElement} mediaGallery - Das media-gallery Custom Element
     * @param {string} productHandle - Shopify Product Handle (z.B. "klassik-weiss-gold")
     */
    async fetchAndReplaceGalleryImages(mediaGallery, productHandle) {
      // Cancel any previous fetch request to prevent race conditions
      if (this.imageLoadAbortController) {
        this.imageLoadAbortController.abort();
      }
      this.imageLoadAbortController = new AbortController();
      const { signal } = this.imageLoadAbortController;

      // Clear any previous safety timeout
      if (this.loadingTimeoutId) {
        clearTimeout(this.loadingTimeoutId);
        this.loadingTimeoutId = null;
      }

      try {
        // Add loading state
        mediaGallery.classList.add('is-loading');

        const response = await fetch(`/products/${productHandle}.json`, { signal });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        const product = data.product;

        if (!product || !product.images || product.images.length === 0) {
          mediaGallery.classList.remove('is-loading');
          return;
        }

        // Transform images to our format
        const images = product.images.map((img) => ({
          url: img.src,
          width: img.width,
          height: img.height,
          alt: img.alt || product.title
        }));

        // Replace all gallery images
        this.replaceAllGalleryImages(mediaGallery, images);

      } catch (error) {
        // Ignore abort errors (expected when user clicks quickly)
        if (error.name === 'AbortError') {
          return;
        }
        // console.error('Failed to fetch product images:', error);
        mediaGallery.classList.remove('is-loading');
      }
    }

    /**
     * ═══════════════════════════════════════════════════════════════════════════════════
     * REPLACE ALL GALLERY IMAGES - Ersetzt ALLE Galeriebilder und reinitialisiert Swiper
     * ═══════════════════════════════════════════════════════════════════════════════════
     *
     * Diese Methode führt einen vollständigen Austausch der Produktgalerie durch.
     *
     * WARUM IST DAS KOMPLEX?
     * ──────────────────────
     * Die Produktgalerie verwendet:
     * 1. Swiper.js für das Hauptkarussell (horizontales Swipen)
     * 2. Swiper.js für die Thumbnails (mit Thumbs-Verbindung zum Hauptkarussell)
     * 3. PhotoSwipe für die Lightbox (Vollbildansicht beim Klick)
     *
     * Bei einem Bildaustausch müssen alle drei Instanzen zerstört und neu initialisiert
     * werden, da sie DOM-Referenzen und Event-Listener auf die alten Elemente haben.
     *
     * ABLAUF:
     * ───────
     * 1. Loading-State hinzufügen (visuelles Feedback)
     * 2. Neue Slides als HTML generieren (createMediaSlide, createThumbSlide)
     * 3. Swiper-Instanzen zerstören (destroy)
     * 4. DOM-Inhalt ersetzen (innerHTML)
     * 5. Slide-Index auf 0 zurücksetzen
     * 6. Swiper neu initialisieren (initSlider)
     * 7. PhotoSwipe/Lightbox neu initialisieren
     * 8. Loading-State entfernen
     *
     * WICHTIG - sliderInstance = false:
     * ──────────────────────────────────
     * Nach destroy() wird sliderInstance auf `false` (nicht null) gesetzt, weil:
     * typeof null === 'object' → würde initSlider() verhindern
     * typeof false === 'boolean' → initSlider() erkennt: nicht initialisiert
     *
     * @param {HTMLElement} mediaGallery - Das media-gallery Custom Element
     * @param {Array} images - Array von Bildobjekten { url, width, height, alt }
     */
    replaceAllGalleryImages(mediaGallery, images) {
      const mediaList = mediaGallery.querySelector('[id^="Slider-Gallery"]');
      const thumbsWrapper = mediaGallery.querySelector('[id^="GalleryThumbnails"] .swiper-wrapper');

      if (!mediaList) {
        // console.log('❌ ABORT: mediaList not found');
        return;
      }

      // 1. Add loading state
      mediaGallery.classList.add('is-loading');

      // 2. Generate new slides HTML
      const newSlides = images.map((img, index) => this.createMediaSlide(img, index)).join('');
      const newThumbs = images.map((img, index) => this.createThumbSlide(img, index)).join('');

      // 3. Destroy Swiper instances (if active)
      // IMPORTANT: Set to `false` (not null) because typeof null === 'object' in JS
      // The media-gallery's initSlider() checks: if (typeof this.sliderInstance !== 'object')
      if (mediaGallery.sliderInstance && mediaGallery.sliderInstance.slider) {
        mediaGallery.sliderInstance.slider.destroy(true, true);
        mediaGallery.sliderInstance = false;
      }
      if (mediaGallery.thumbsInstance && mediaGallery.thumbsInstance.slider) {
        mediaGallery.thumbsInstance.slider.destroy(true, true);
        mediaGallery.thumbsInstance = false;
      }

      // 4. Replace DOM content
      mediaList.innerHTML = newSlides;
      if (thumbsWrapper) {
        thumbsWrapper.innerHTML = newThumbs;
      }

      // 5. Reset slide index to 0 (new images = start from first slide)
      const viewerWrap = document.querySelector('.product__media-gallery-viewer-wrap');
      if (viewerWrap) {
        viewerWrap.dataset.currentSlide = '0';
      }
      const overlay = document.querySelector('[data-accessories-overlay]');
      if (overlay) {
        overlay.classList.remove('is-hidden-by-slide');
      }

      // 6. Reinitialize Swiper with thumbs connection
      // Use requestAnimationFrame to ensure DOM is ready
      // Safety timeout: Remove loading state after 8 seconds max (fallback if onload/onerror don't fire)
      if (this.loadingTimeoutId) {
        clearTimeout(this.loadingTimeoutId);
      }
      this.loadingTimeoutId = setTimeout(() => {
        mediaGallery.classList.remove('is-loading');
      }, 8000);

      requestAnimationFrame(() => {
        try {
          if (typeof mediaGallery.initSlider === 'function') {
            mediaGallery.initSlider();
          }

          // 7. Re-bind slide change events for overlay visibility
          if (mediaGallery.sliderInstance && mediaGallery.sliderInstance.slider) {
            const swiper = mediaGallery.sliderInstance.slider;
            swiper.on('slideChange', () => {
              this.updateOverlayVisibilityForSlide(swiper.realIndex);
            });
          }

          // 8. Reinitialize PhotoSwipe lightbox
          if (mediaGallery.lightbox) {
            mediaGallery.lightbox.destroy();
            mediaGallery.lightbox = null;
          }
          if (mediaGallery.enableImageZoom && typeof mediaGallery.initImageZoom === 'function') {
            mediaGallery.initImageZoom();
          }

          // 9. Remove loading state after images load
          const firstImg = mediaList.querySelector('img');
          if (firstImg) {
            const removeLoading = () => {
              mediaGallery.classList.remove('is-loading');
              if (this.loadingTimeoutId) {
                clearTimeout(this.loadingTimeoutId);
                this.loadingTimeoutId = null;
              }
            };

            if (firstImg.complete) {
              removeLoading();
            } else {
              firstImg.onload = removeLoading;
              firstImg.onerror = removeLoading;
            }
          } else {
            mediaGallery.classList.remove('is-loading');
            if (this.loadingTimeoutId) {
              clearTimeout(this.loadingTimeoutId);
              this.loadingTimeoutId = null;
            }
          }

          // 10. Remove loading state from thumbnails after each image loads
          if (thumbsWrapper) {
            const thumbItems = thumbsWrapper.querySelectorAll('.product__thumbs-item.is-loading');
            thumbItems.forEach((thumb) => {
              const img = thumb.querySelector('img');
              if (img) {
                if (img.complete) {
                  thumb.classList.remove('is-loading');
                } else {
                  img.onload = () => thumb.classList.remove('is-loading');
                  img.onerror = () => thumb.classList.remove('is-loading');
                }
              } else {
                thumb.classList.remove('is-loading');
              }
            });
          }
        } catch (error) {
          // Ensure loading state is removed even if Swiper/PhotoSwipe initialization fails
          mediaGallery.classList.remove('is-loading');
          if (this.loadingTimeoutId) {
            clearTimeout(this.loadingTimeoutId);
            this.loadingTimeoutId = null;
          }
        }
      });
    }

    /**
     * Create HTML for a gallery slide
     */
    createMediaSlide(img, index) {
      const baseUrl = (img.url || '').split('?')[0];
      if (!baseUrl) return '';

      const widths = [400, 620, 690, 810, 980, 1240, 1380, 1620];
      const srcset = widths.map((w) => `${baseUrl}?width=${w} ${w}w`).join(', ');
      const mainSrc = `${baseUrl}?width=1240`;
      const fullSrc = `${baseUrl}?width=1946`;
      const imgWidth = img.width || 1946;
      const imgHeight = img.height || 1946;
      const aspectRatio = imgWidth / imgHeight;
      const altText = this.escapeHtml(img.alt || img.altText || '');

      return `
        <div role="listitem" tabindex="-1"
             class="product__media-item swiper-slide"
             data-media-id="dynamic-${index}"
             data-media-type="image"
             data-media-index="${index}"
             data-src="${fullSrc}"
             data-pswp-width="${imgWidth}"
             data-pswp-height="${imgHeight}">
          <div class="product__media-container blocks-radius media-type-image"
               style="--aspect-ratio: ${aspectRatio};">
            <img src="${mainSrc}"
                 srcset="${srcset}"
                 sizes="(min-width: 1200px) 620px, (min-width: 990px) calc(50vw - 40px), calc(100vw - 40px)"
                 loading="${index === 0 ? 'eager' : 'lazy'}"
                 alt="${altText}"
                 width="${imgWidth}"
                 height="${imgHeight}">
          </div>
        </div>
      `;
    }

    /**
     * Create HTML for a thumbnail slide
     */
    createThumbSlide(img, index) {
      const baseUrl = (img.url || '').split('?')[0];
      if (!baseUrl) return '';

      const widths = [70, 100, 140, 150, 200, 300, 400];
      const srcset = widths.map((w) => `${baseUrl}?width=${w} ${w}w`).join(', ');
      const altText = this.escapeHtml(img.alt || img.altText || '');

      return `
        <div class="product__thumbs-item swiper-slide is-loading"
             data-target="dynamic-${index}"
             data-media-position="${index + 1}">
          <div class="product__thumbs-container medium-blocks-radius media-wrapper">
            <div class="product__thumbs-inner" style="--aspect-ratio: 1;">
              <img src="${baseUrl}?width=200"
                   srcset="${srcset}"
                   sizes="100px"
                   loading="lazy"
                   alt="${altText}">
            </div>
          </div>
        </div>
      `;
    }

    /**
     * Update only the first image (backwards compatibility for single-image data)
     */
    updateFirstImageOnly(mediaGallery, imageUrl) {
      // Generate srcset for different widths
      const baseUrl = imageUrl.split('?')[0];
      const widths = [400, 620, 690, 810, 980, 1240, 1380, 1620];
      const srcset = widths.map((w) => `${baseUrl}?width=${w} ${w}w`).join(', ');
      const mainSrc = `${baseUrl}?width=1946`;

      // Find ALL slides with data-media-index="0" (the first image + its Swiper duplicates)
      const firstSlides = mediaGallery.querySelectorAll('.product__media-item[data-media-index="0"]');

      if (firstSlides.length === 0) {
        return;
      }

      // Update all first slides (original + duplicates)
      firstSlides.forEach((slide) => {
        const imgEl = slide.querySelector('img');
        if (imgEl) {
          slide.classList.add('is-loading');
          imgEl.src = mainSrc;
          imgEl.srcset = srcset;
          imgEl.onload = () => slide.classList.remove('is-loading');
          imgEl.onerror = () => slide.classList.remove('is-loading');
          slide.dataset.src = mainSrc;
        }
      });

      // Update the first thumbnail
      const firstThumb = mediaGallery.querySelector('.product__thumbs-item[data-media-position="1"] img');
      if (firstThumb) {
        const thumbWidths = [70, 100, 140, 150, 200, 300, 400];
        const thumbSrcset = thumbWidths.map((w) => `${baseUrl}?width=${w} ${w}w`).join(', ');
        firstThumb.src = `${baseUrl}?width=400`;
        firstThumb.srcset = thumbSrcset;
      }

      // Update PhotoSwipe lightbox dataSource for the first image
      if (mediaGallery.lightbox?.options?.dataSource) {
        const firstImageEntry = mediaGallery.lightbox.options.dataSource.find(
          (item) => item.id === '0' || item.id === 0
        );
        if (firstImageEntry?.mediaType === 'image') {
          firstImageEntry.src = mainSrc;
        }
      }
    }

    /**
     * Update the product title based on current selection
     */
    updateProductTitle() {
      // Skip if title changes are disabled
      if (this.config?.allowTitleChange === false) {
        return;
      }

      // Check if URL has parameters (for shared links) or user has interacted
      const hasUrlParams = window.location.search.includes('lk_');

      // Skip title update only on initial load without URL parameters
      // The setTimeout in connectedCallback sets isInitialLoad=false after first render
      if (!hasUrlParams && !this.hasUserInteracted) {
        // console.log('=== updateProductTitle() SKIPPED (initial load without URL params) ===');
        return;
      }
      // console.log('=== updateProductTitle() RUNNING ===');
      // console.log('hasUrlParams:', hasUrlParams, 'hasUserInteracted:', this.hasUserInteracted);

      // Get the product title from produktbilder (Form + Farbe + Bügel → full product title)
      // This gives us the complete title like "LIEBLINGSKORB Black Edge gold"
      const normalizeValue = (value) => {
        if (!value) return '';
        return value.toLowerCase().trim();
      };

      const selectedFormNorm = normalizeValue(this.selectedForm);
      const selectedFarbeNorm = normalizeValue(this.selectedFarbe);
      const selectedBuegelNorm = normalizeValue(this.selectedBuegel);

      const matchingProduktbild = this.produktbilder?.find((p) => {
        return (
          normalizeValue(p.form) === selectedFormNorm &&
          normalizeValue(p.korbFarbe) === selectedFarbeNorm &&
          normalizeValue(p.buegelFarbe) === selectedBuegelNorm
        );
      });

      // console.log('=== updateProductTitle: matchingProduktbild ===', matchingProduktbild);
      let newTitle = matchingProduktbild?.productTitle || 'LIEBLINGSKORB';
      // console.log('=== updateProductTitle: newTitle from produktbild ===', newTitle);

      // Add secondary buegel color to title if enabled and selected
      // Title from produktbilder already contains primary buegel color (e.g. "LIEBLINGSKORB® Basic silver grey champagner")
      // We need to add the secondary color (e.g. "LIEBLINGSKORB® Basic silver grey champagner + tiefschwarz")
      if (this.allowSecondaryBuegel && this.selectedBuegelSecondary) {
        // Get the display label for the secondary buegel color
        const secondaryBuegelBtn = this.querySelector(`[data-group="buegel-secondary"] [data-option-value][data-option-label]`);
        const secondaryButtons = this.querySelectorAll('[data-group="buegel-secondary"] [data-option-value]');
        let secondaryLabel = this.selectedBuegelSecondary;

        // Find the button with matching value to get its label
        secondaryButtons.forEach((btn) => {
          if (this.normalizeValue(btn.dataset.optionValue) === this.normalizeValue(this.selectedBuegelSecondary)) {
            secondaryLabel = btn.dataset.optionLabel || this.selectedBuegelSecondary;
          }
        });

        newTitle += ' + ' + secondaryLabel;
      }

      // Collect selected accessory labels
      const accessoryLabels = [];
      // console.log('=== updateProductTitle V2: Collecting accessory labels ===');
      // console.log('accessoryItems count:', this.accessoryItems.length);

      this.accessoryItems.forEach((item, index) => {
        // console.log(`Item ${index}: hidden=${item.hidden}, key=${item.dataset.accessoryKey}`);
        if (item.hidden) return;
        const checkbox = item.querySelector('input[type="checkbox"]');
        // Find the title element that has data-label attribute
        const titleEl = item.querySelector('.bundle-configurator__accessory-title[data-label]');
        // console.log(`  checkbox exists: ${!!checkbox}, checked: ${checkbox?.checked}`);
        // console.log(`  titleEl exists: ${!!titleEl}`);
        if (titleEl) {
          // console.log(`  titleEl outerHTML: ${titleEl.outerHTML.substring(0, 200)}`);
          // console.log(`  titleEl.dataset.label: "${titleEl.dataset.label}"`);
          // console.log(`  titleEl.getAttribute('data-label'): "${titleEl.getAttribute('data-label')}"`);
        }
        if (checkbox && checkbox.checked && titleEl) {
          // Use the data-label attribute (short name like "Deckel", "Einlegeboden")
          const label = titleEl.getAttribute('data-label');
          // console.log(`  → Found label: "${label}"`);
          if (label && label.trim()) {
            accessoryLabels.push(label.trim());
          }
        }
      });

      // console.log('Collected accessoryLabels:', accessoryLabels);

      // Append accessories to title with proper German formatting
      // "inkl. Deckel, Einlegeboden und Transportring"
      if (accessoryLabels.length > 0) {
        let accessoryText;
        if (accessoryLabels.length === 1) {
          accessoryText = accessoryLabels[0];
        } else if (accessoryLabels.length === 2) {
          accessoryText = accessoryLabels.join(' und ');
        } else {
          // Join all but last with comma, then add "und" before last
          const allButLast = accessoryLabels.slice(0, -1).join(', ');
          const last = accessoryLabels[accessoryLabels.length - 1];
          accessoryText = allButLast + ' und ' + last;
        }
        newTitle += ', inkl. ' + accessoryText;
      }

      // console.log('=== updateProductTitle: Final title ===');
      // console.log('Updating product title to:', newTitle);

      // Convert ® to superscript for proper display
      // newTitle is plain text from produktbild.productTitle, so we can safely replace
      const formattedTitle = newTitle.replace(/®/g, '<sup style="font-size: 0.5em; top: -0.2em; position: relative;">®</sup>');

      // Find and update all title elements
      const titleBlock = document.querySelector('.product__block--title');
      if (titleBlock) {
        const h1 = titleBlock.querySelector('h1.product__title');
        const h2 = titleBlock.querySelector('h2.h1');

        if (h1) {
          h1.innerHTML = formattedTitle;
          // console.log('Updated h1.product__title');
        }
        if (h2) {
          h2.innerHTML = formattedTitle;
          // console.log('Updated h2.h1');
        }
      } else {
        // console.log('❌ .product__block--title not found');
      }
    }

    /**
     * Update the main product price display on the page
     */
    updateMainPrice(total, subtotal, discount) {
      // Find price container (works with different template IDs)
      const priceContainer = document.querySelector('[id^="price-template--"]');
      if (!priceContainer) return;

      const regularPriceEl = priceContainer.querySelector('.f-price__regular .f-price-item--regular');
      const salePriceEl = priceContainer.querySelector('.f-price__sale .f-price-item--sale');
      const saleRegularEl = priceContainer.querySelector('.f-price__sale .f-price-item--regular s');
      const priceWrapper = priceContainer.querySelector('.f-price');

      // Find or create savings badge
      let savingsBadge = priceContainer.querySelector('.bundle-savings-badge');
      if (!savingsBadge) {
        savingsBadge = document.createElement('span');
        savingsBadge.className = 'bundle-savings-badge';
        savingsBadge.style.cssText = 'display: inline-flex; align-items: center; justify-content: center; background-color: #16a34a; color: #fff; font-size: 1.125rem; font-weight: 600; padding: 0.5rem 0.75rem; border-radius: 0.375rem; white-space: nowrap; margin-left: 1.25rem;';
        if (priceWrapper) {
          priceWrapper.appendChild(savingsBadge);
        }
      }

      if (discount > 0) {
        // Show sale price styling
        if (priceWrapper) {
          priceWrapper.classList.add('f-price--on-sale');
        }
        if (salePriceEl) {
          salePriceEl.textContent = this.formatMoney(total);
        }
        if (saleRegularEl) {
          saleRegularEl.textContent = this.formatMoney(subtotal);
        }
        if (regularPriceEl) {
          regularPriceEl.textContent = this.formatMoney(total);
        }
        // Show savings percentage badge
        if (savingsBadge && subtotal > 0) {
          const savingsPercent = Math.floor((discount / subtotal) * 100);
          savingsBadge.textContent = `Spare ${savingsPercent}%`;
          savingsBadge.style.display = 'inline-flex';
        }
      } else {
        // Show regular price styling
        if (priceWrapper) {
          priceWrapper.classList.remove('f-price--on-sale');
        }
        if (regularPriceEl) {
          regularPriceEl.textContent = this.formatMoney(total);
        }
        if (salePriceEl) {
          salePriceEl.textContent = this.formatMoney(total);
        }
        // Hide savings badge when no discount
        if (savingsBadge) {
          savingsBadge.style.display = 'none';
        }
      }
    }

    /**
     * Initialize mobile sticky cart
     */
    initStickyCart() {
      if (!this.stickyCart) return;

      // Check if user has seen a buy button in viewport on any product page before
      // Only show sticky cart if they have (to avoid confusing first-time visitors)
      let hasSeenBuyButton = false;
      try {
        hasSeenBuyButton = localStorage.getItem('lk_seen_buy_button') === 'true';
      } catch (e) {
        // localStorage not available, default to not showing
      }

      if (!hasSeenBuyButton) {
        // User hasn't seen a regular buy button yet, hide sticky cart completely
        this.stickyCart.hidden = true;
        // Set up observer to mark when user sees a buy button (for future visits)
        this.observeBuyButtonVisibility();
        return;
      }

      // Move sticky cart to body to ensure position:fixed works
      // (avoids issues with ancestor elements having transform/filter/will-change)
      document.body.appendChild(this.stickyCart);

      // Bind add-to-cart button
      if (this.stickyAddToCartBtn) {
        this.stickyAddToCartBtn.addEventListener('click', () => this.addToCart());
      }

      // Check if there are any recommended accessories
      const hasRecommendedAccessories = this.hasVisibleRecommendedAccessories();

      if (hasRecommendedAccessories) {
        // With recommended accessories: show sticky cart on scroll immediately
        this.setupStickyCartObserver();
      } else {
        // Without recommended accessories: keep sticky cart hidden until first add-to-cart
        this.stickyCartEnabled = false;
      }

      // Hide sticky cart when cart drawer is open
      this.bindCartDrawerEvents();
    }

    /**
     * Observe when user scrolls a regular buy button into viewport
     * Sets localStorage flag so sticky cart is shown on future visits
     */
    observeBuyButtonVisibility() {
      // Find regular buy buttons (not bundle configurator ones)
      const buyButton = document.querySelector('.product-form__submit[name="add"]');
      if (!buyButton) return;

      // Use Intersection Observer to detect when button becomes visible
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              try {
                localStorage.setItem('lk_seen_buy_button', 'true');
              } catch (e) {
                // localStorage not available
              }
              observer.disconnect();
            }
          });
        },
        { threshold: 0.5 } // At least 50% visible
      );

      observer.observe(buyButton);
    }

    /**
     * Bind events to hide sticky cart when cart drawer is open
     */
    bindCartDrawerEvents() {
      if (!this.stickyCart) return;

      // Listen for drawer show/hide events
      document.addEventListener('drawer:handleAfterShow', (e) => {
        // Check if it's the cart drawer
        if (e.target && e.target.id === 'cart-drawer') {
          this.stickyCart.classList.add('is-drawer-open');
        }
      });

      document.addEventListener('drawer:handleAfterHide', (e) => {
        // Check if it's the cart drawer
        if (e.target && e.target.id === 'cart-drawer') {
          this.stickyCart.classList.remove('is-drawer-open');
        }
      });
    }

    /**
     * Check if there are any visible recommended accessories
     */
    hasVisibleRecommendedAccessories() {
      let hasRecommended = false;
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        if (item.dataset.empfohlen === 'true') {
          hasRecommended = true;
        }
      });
      return hasRecommended;
    }

    /**
     * Enable sticky cart (called after first add-to-cart when no recommended accessories)
     */
    enableStickyCart() {
      if (this.stickyCartEnabled) return;
      this.stickyCartEnabled = true;
      this.setupStickyCartObserver();
    }

    /**
     * Setup intersection observer to show/hide sticky cart
     */
    setupStickyCartObserver() {
      if (!this.stickyCart) return;

      // Find the summary section as the trigger point
      const summarySection = this.querySelector('.bundle-configurator__summary');
      if (!summarySection) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // Show sticky cart when summary is NOT visible
            if (entry.isIntersecting) {
              this.hideStickyCart();
            } else {
              this.showStickyCart();
            }
          });
        },
        {
          root: null,
          threshold: 0,
          rootMargin: '-100px 0px 0px 0px'
        }
      );

      observer.observe(summarySection);
      this.stickyCartObserver = observer;
    }

    /**
     * Show sticky cart with body class management
     * Adds 'sticky-cart-showing' during animation, then 'sticky-cart-shown' when complete
     */
    showStickyCart() {
      if (!this.stickyCart || this.stickyCart.classList.contains('is-visible')) return;

      // Add showing class during animation
      document.body.classList.add('sticky-cart-showing');
      document.body.classList.remove('sticky-cart-shown');

      this.stickyCart.classList.add('is-visible');

      // Listen for animation end to swap classes
      const onAnimationEnd = () => {
        document.body.classList.remove('sticky-cart-showing');
        document.body.classList.add('sticky-cart-shown');
        this.stickyCart.removeEventListener('transitionend', onAnimationEnd);
      };

      this.stickyCart.addEventListener('transitionend', onAnimationEnd);

      // Fallback timeout in case transitionend doesn't fire
      setTimeout(() => {
        if (document.body.classList.contains('sticky-cart-showing')) {
          document.body.classList.remove('sticky-cart-showing');
          document.body.classList.add('sticky-cart-shown');
        }
      }, 400);
    }

    /**
     * Hide sticky cart and remove body classes
     */
    hideStickyCart() {
      if (!this.stickyCart || !this.stickyCart.classList.contains('is-visible')) return;

      // Add showing class during hide animation
      document.body.classList.add('sticky-cart-showing');
      document.body.classList.remove('sticky-cart-shown');

      this.stickyCart.classList.remove('is-visible');

      // Listen for animation end to remove all classes
      const onAnimationEnd = () => {
        document.body.classList.remove('sticky-cart-showing');
        this.stickyCart.removeEventListener('transitionend', onAnimationEnd);
      };

      this.stickyCart.addEventListener('transitionend', onAnimationEnd);

      // Fallback timeout
      setTimeout(() => {
        document.body.classList.remove('sticky-cart-showing');
      }, 400);
    }

    /**
     * Update sticky cart price display and product image
     */
    updateStickyCart(total, subtotal, discount, accessoriesCount, giftsCount = 0) {
      if (!this.stickyCart) return;

      // Update total price
      if (this.stickyTotal) {
        this.stickyTotal.textContent = this.formatMoney(total);
      }

      // Update compare price (strikethrough)
      if (this.stickyCompare) {
        if (discount > 0) {
          this.stickyCompare.textContent = this.formatMoney(subtotal);
          this.stickyCompare.hidden = false;
        } else {
          this.stickyCompare.hidden = true;
        }
      }

      // Update accessory badge - now includes both accessories and gifts
      if (this.stickyBadge && this.stickyBadgeCount) {
        const totalExtras = accessoriesCount + giftsCount;
        if (totalExtras > 0) {
          this.stickyBadgeCount.textContent = totalExtras;
          this.stickyBadge.hidden = false;
        } else {
          this.stickyBadge.hidden = true;
        }
      }

      // Update sticky cart product image
      this.updateStickyCartImage();
    }

    /**
     * Update sticky cart product image based on current selection
     * Uses the same produktbilder data as updateMainProductImage
     */
    updateStickyCartImage() {
      if (!this.stickyImage) return;
      if (!this.produktbilder || this.produktbilder.length === 0) return;

      // Find matching produktbild for current selection
      const selectedFormNorm = this.normalizeValue(this.selectedForm);
      const selectedFarbeNorm = this.normalizeValue(this.selectedFarbe);
      const selectedBuegelNorm = this.normalizeValue(this.selectedBuegel);

      const matching = this.produktbilder.find((p) => {
        return (
          this.normalizeValue(p.form) === selectedFormNorm &&
          this.normalizeValue(p.korbFarbe) === selectedFarbeNorm &&
          this.normalizeValue(p.buegelFarbe) === selectedBuegelNorm
        );
      });

      if (!matching) return;

      // Show loading state
      this.stickyImage.classList.add('is-loading');

      // Prefer productHandle (same priority as updateMainProductImage)
      if (matching.productHandle) {
        this.fetchStickyCartImage(matching.productHandle);
      } else if (matching.image) {
        // Fallback: use image from produktbilder mapping
        const baseUrl = matching.image.split('?')[0];
        const imageUrl = `${baseUrl}?width=90`;
        this.setStickyCartImageSrc(imageUrl, matching.productTitle || 'Produkt');
      }
    }

    /**
     * Set sticky cart image source and handle loading state
     */
    setStickyCartImageSrc(imageUrl, altText) {
      if (!this.stickyImage) return;

      const img = new Image();
      img.onload = () => {
        this.stickyImage.innerHTML = `<img src="${imageUrl}" alt="${this.escapeHtml(altText)}" width="45" height="45" loading="lazy">`;
        this.stickyImage.classList.remove('is-loading');
      };
      img.onerror = () => {
        this.stickyImage.classList.remove('is-loading');
      };
      img.src = imageUrl;
    }

    /**
     * Fetch product image for sticky cart via Shopify JSON API
     */
    async fetchStickyCartImage(productHandle) {
      if (!this.stickyImage) return;

      try {
        const response = await fetch(`/products/${productHandle}.json`);
        if (!response.ok) {
          this.stickyImage.classList.remove('is-loading');
          return;
        }

        const data = await response.json();
        const product = data.product;

        if (product && product.images && product.images.length > 0) {
          const baseUrl = product.images[0].src.split('?')[0];
          const imageUrl = `${baseUrl}?width=90`;
          this.setStickyCartImageSrc(imageUrl, product.title || 'Produkt');
        } else {
          this.stickyImage.classList.remove('is-loading');
        }
      } catch (error) {
        // Silently fail - keep existing image
        this.stickyImage.classList.remove('is-loading');
      }
    }

    updateBanners() {
      // Always update gifts visibility first (for all bundle types)
      this.updateGiftsVisibility();

      if (this.isBundle) {
        // In bundle mode, always show success banner if visible accessories exist
        if (this.successBanner) {
          this.successBanner.hidden = false;
        }
        if (this.warningBanner) {
          this.warningBanner.hidden = true;
        }
        return;
      }

      // Get missing accessories
      const missingAccessories = this.getMissingAccessories();

      if (missingAccessories.length === 0) {
        // All selected - show success
        if (this.warningBanner) this.warningBanner.hidden = true;
        if (this.successBanner) this.successBanner.hidden = !this.areAllCompatibleAccessoriesSelected();
      } else {
        // Some missing - show warning
        if (this.successBanner) this.successBanner.hidden = true;
        if (this.warningBanner) {
          this.warningBanner.hidden = false;
          if (this.missingList) {
            this.missingList.innerHTML = missingAccessories
              .map(
                (acc) =>
                  `<li class="bundle-configurator__missing-item flex items-start gap-2">
                    <span class="bundle-configurator__missing-icon" aria-hidden="true">✕</span>
                    <span><strong>${this.escapeHtml(acc.title)}</strong>${acc.benefit ? ' – ' + this.escapeHtml(acc.benefit) : ''}</span>
                  </li>`
              )
              .join('');
          }
        }
      }
    }

    /**
     * Show/hide Gratisgeschenke section based on whether all pre-selected accessories are selected.
     * Gifts are only available when the user has all vorausgewaehlt accessories checked.
     */
    updateGiftsVisibility() {
      if (!this.giftsSection) return;

      // If accessory changes are not allowed (locked accessories), always show gifts
      if (!this.allowAccessoryChange) {
        this.giftsSection.hidden = false;
        return;
      }

      // For configurable bundles, only show gifts when all PRE-SELECTED accessories are selected
      const allPreselectedSelected = this.areAllCompatibleAccessoriesSelected();
      this.giftsSection.hidden = !allPreselectedSelected;
    }

    /**
     * Check if Gratisgeschenke should be included (all pre-selected accessories are selected)
     */
    areGiftsIncluded() {
      // If accessory changes are not allowed (locked accessories), gifts are always included
      if (!this.allowAccessoryChange) return true;

      // For configurable bundles, gifts only included when all PRE-SELECTED accessories are selected
      return this.areAllCompatibleAccessoriesSelected();
    }

    getMissingAccessories() {
      const missing = [];
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        // Only show "empfohlen" (recommended) items in the warning banner
        // Purely optional items like ICY Box should not appear here
        const isEmpfohlen = item.dataset.empfohlen === 'true';
        if (!isEmpfohlen) return;

        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox && !checkbox.checked) {
          // Get short label from data-label attribute for banner display
          const titleEl = item.querySelector('[data-label]');
          const title = titleEl ? titleEl.getAttribute('data-label') : checkbox.dataset.accessoryTitle || '';
          missing.push({
            title: title,
            benefit: checkbox.dataset.accessoryBenefit || '',
          });
        }
      });
      return missing;
    }

    areAllCompatibleAccessoriesSelected() {
      // Check if all PRE-SELECTED (vorausgewaehlt) accessories are still selected
      // This determines if the bundle is complete and gifts should be shown
      let allPreselectedChecked = true;
      let hasAnyPreselected = false;
      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        // Only check items that are marked as vorausgewaehlt (pre-selected)
        const isVorausgewaehlt = item.dataset.vorausgewaehlt === 'true';
        if (!isVorausgewaehlt) return;

        hasAnyPreselected = true;
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (!checkbox || !checkbox.checked) {
          allPreselectedChecked = false;
          return;
        }
        
        // Check if this item belongs to a bundle group
        const bundleGroupName = item.dataset.bundleGroup;
        if (bundleGroupName) {
          const parentBundle = this.querySelector(`[data-accessory-bundle][data-bundle-group="${bundleGroupName}"]`);
          if (parentBundle) {
            const bundleCheckbox = parentBundle.querySelector('[data-bundle-checkbox]');
            if (!bundleCheckbox || !bundleCheckbox.checked) {
              allPreselectedChecked = false;
            }
          }
        }
      });
      return hasAnyPreselected && allPreselectedChecked;
    }

    /**
     * Get selected Korb data from korbMappings (Form × Farbe → Variante)
     * Each mapping directly references a single variant.
     */
    getSelectedKorbData() {
      const formNorm = this.normalizeValue(this.selectedForm);
      const farbeNorm = this.normalizeValue(this.selectedFarbe);

      return this.korbMappings.find((m) => {
        return this.normalizeValue(m.form) === formNorm && this.normalizeValue(m.farbe) === farbeNorm;
      });
    }

    /**
     * Get selected bügel data from buegelMappings (Korbfarbe × Bügelfarbe → Produkt)
     * @param {string} sequence - 'primary' (default) or 'secondary'
     */
    getSelectedBuegelData(sequence = 'primary') {
      const selectedBuegel = sequence === 'secondary' ? this.selectedBuegelSecondary : this.selectedBuegel;
      const buegelNorm = this.normalizeValue(selectedBuegel);
      const farbeNorm = this.normalizeValue(this.selectedFarbe);

      if (!buegelNorm) return null;

      return this.buegelMappings.find(
        (m) =>
          this.normalizeValue(m.buegelFarbe) === buegelNorm &&
          this.normalizeValue(m.korbFarbe) === farbeNorm
      );
    }

    normalizeValue(value) {
      if (!value) return '';
      return value
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9äöüß]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      const format = this.config.moneyFormat || '{{amount}} €';
      const formatted = format.replace('{{amount}}', amount).replace('{{amount_with_comma_separator}}', amount);
      // Remove ,00 from whole Euro amounts
      return formatted.replace(',00 €', ' €');
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    /**
     * Get the custom title and image for cart line item based on current selection
     * @returns {Object} Object with title and image properties
     */
    getCartLineUpdate() {
      const form = this.selectedForm || '';
      const korbFarbe = this.selectedFarbe || '';
      const buegelFarbe = this.selectedBuegel || '';

      // Capitalize first letter
      const capitalize = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      };

      // Build title: "LIEBLINGSKORB [Form] [Korbfarbe] mit [Bügelfarbe] Bügel"
      let title = 'LIEBLINGSKORB';
      if (form) {
        title += ` ${capitalize(form)}`;
      }
      if (korbFarbe) {
        title += ` ${capitalize(korbFarbe)}`;
      }
      if (buegelFarbe) {
        title += ` mit ${capitalize(buegelFarbe)} Bügel`;
      }

      // Find matching produktbild for the image
      let image = null;
      if (this.produktbilder && this.produktbilder.length > 0) {
        const normalizeValue = (value) => {
          if (!value) return '';
          return value.toLowerCase().trim();
        };

        const selectedFormNorm = normalizeValue(this.selectedForm);
        const selectedFarbeNorm = normalizeValue(this.selectedFarbe);
        const selectedBuegelNorm = normalizeValue(this.selectedBuegel);

        const matching = this.produktbilder.find((p) => {
          const formNorm = normalizeValue(p.form);
          const korbFarbeNorm = normalizeValue(p.korbFarbe);
          const buegelFarbeNorm = normalizeValue(p.buegelFarbe);

          return (
            formNorm === selectedFormNorm &&
            korbFarbeNorm === selectedFarbeNorm &&
            buegelFarbeNorm === selectedBuegelNorm
          );
        });

        if (matching && matching.image) {
          // Ensure image URL is absolute with https:
          let imageUrl = matching.image;
          if (imageUrl.startsWith('//')) {
            imageUrl = 'https:' + imageUrl;
          } else if (!imageUrl.startsWith('http')) {
            imageUrl = 'https://' + imageUrl;
          }
          image = imageUrl;
        }
      }

      return { title, image };
    }

    /**
     * Erstellt das Parent-Item (Korb) für den Warenkorb.
     *
     * Das Parent-Item ist der "Haupt-Artikel" des Bundles. Alle anderen Teile
     * (Bügel, Zubehör) werden als Children mit parent_id referenziert.
     *
     * @returns {Object|null} Cart-Item Objekt { id, quantity, properties } oder null
     */
    getParentCartItem() {
      // Get korb data - this is the parent product
      const korbData = this.getSelectedKorbData();
      if (!korbData || !korbData.variantId) {
        return null;
      }

      const parentVariantId = parseInt(korbData.variantId, 10);
      if (isNaN(parentVariantId) || parentVariantId <= 0) {
        return null;
      }

      // Get custom title and image for cart line
      const lineUpdate = this.getCartLineUpdate();

      // Build _update JSON for cart line customization
      const updateData = {};
      if (korbData.price) {
        updateData.price = (korbData.price / 100).toFixed(2);
      }
      if (lineUpdate.title) {
        updateData.title = lineUpdate.title;
      }
      if (lineUpdate.image) {
        updateData.image = lineUpdate.image;
      }

      const parentItem = {
        id: parentVariantId,
        quantity: 1,
        properties: {},
      };

      // Add _update as JSON string if we have custom data
      // if (Object.keys(updateData).length > 0) {
      //   parentItem.properties._update = JSON.stringify(updateData);
      // }

      return parentItem;
    }

    /**
     * Get child items (Bügel + Zubehör) for adding to cart with parent_id
     * @param {string} parentLineKey - The cart line key of the parent (from /cart/add.js response)
     * @returns {Array} Array of child cart items
     */
    getChildCartItems(parentLineKey) {
      const items = [];

      // If no parent line key, we can't create nested items
      if (!parentLineKey) {
        // console.warn('No parent line key provided, children will be added without nesting');
      }

      // Collect accessories, separating optional items (like ICY Box) from required ones
      const optionalAccessories = []; // vorausgewaehlt=false (like ICY Box)
      const requiredAccessories = []; // vorausgewaehlt=true (Deckel, Einlegeboden, etc.)

      this.accessoryItems.forEach((item) => {
        if (item.hidden) return;
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          const variantIdStr = checkbox.dataset.accessoryVariantId;
          if (variantIdStr) {
            const variantId = parseInt(variantIdStr, 10);
            if (!isNaN(variantId) && variantId > 0) {
              const accessoryItem = {
                id: variantId,
                quantity: 1,
              };

              // Add parent_id if we have a parent line key
              if (parentLineKey) {
                accessoryItem.parent_id = parentLineKey;
              }

              // Check if this is an optional (vorausgewaehlt=false) item
              const isOptional = item.dataset.vorausgewaehlt !== 'true';
              if (isOptional) {
                optionalAccessories.push(accessoryItem);
              } else {
                requiredAccessories.push(accessoryItem);
              }
            }
          }
        }
      });

      // Add optional accessories first (they will appear at the bottom)
      optionalAccessories.forEach((accessory) => items.push(accessory));

      // Add required accessories (reverse order for correct display)
      requiredAccessories.reverse().forEach((accessory) => items.push(accessory));

      // Add bügel as child (appears above accessories)
      const buegelData = this.getSelectedBuegelData('primary');
      if (buegelData && buegelData.variantId) {
        const variantId = parseInt(buegelData.variantId, 10);
        if (!isNaN(variantId) && variantId > 0) {
          const buegelItem = {
            id: variantId,
            quantity: 1,
          };

          // Add parent_id if we have a parent line key
          if (parentLineKey) {
            buegelItem.parent_id = parentLineKey;
          }

          items.push(buegelItem);
        }
      }

      return items;
    }

    /**
     * Get all selected items for adding to cart with bundle structure
     * @returns {Array} Array of cart items with parent_id for nested cart lines
     * @deprecated Use getParentCartItem() and getChildCartItems() instead for proper nested cart lines
     */
    getCartItems() {
      const parentItem = this.getParentCartItem();
      if (!parentItem) {
        return [];
      }

      const parentVariantId = parentItem.id;
      const childItems = this.getChildCartItems(parentVariantId);

      // Build items in REVERSE order because Shopify displays cart items
      // with newest items first. We want: Korb (top) → Bügel → Zubehör → ICY Box (bottom)
      // So children come first (in reverse), then parent last
      const items = [...childItems, parentItem];

      return items;
    }

    /**
     * Generate a unique bundle ID for this cart addition
     * This ensures separate bundles remain distinct even with the same parent variant
     * @returns {string} Unique bundle ID (timestamp + random)
     */
    generateBundleId() {
      const timestamp = Date.now();
      const random = Math.random().toString(36).substring(2, 8);
      return `lk_${timestamp}_${random}`;
    }

    /**
     * Update add-to-cart button state based on availability of Korb and Bügel
     * Disables button and shows message when Korb or Bügel is unavailable
     * Also disables when secondary bügel is required but not selected
     * Note: Unavailable accessories do NOT block the cart - they are simply not selectable
     */
    updateAddToCartButtonState() {
      // Only Korb and Bügel availability affects the add-to-cart button
      // Accessories are handled separately (disabled checkbox, can't be selected)
      const hasUnavailableItems =
        this.unavailableItems.korb ||
        this.unavailableItems.buegel;

      // Check if secondary bügel is required but not selected
      const secondaryBuegelMissing =
        this.allowSecondaryBuegel && !this.selectedBuegelSecondary;

      // Determine overall disabled state and reason
      const isDisabled = hasUnavailableItems || secondaryBuegelMissing;
      let disabledReason = '';
      if (hasUnavailableItems) {
        disabledReason = 'unavailable';
      } else if (secondaryBuegelMissing) {
        disabledReason = 'secondary-buegel-missing';
      }

      // Show/hide secondary bügel validation hint
      if (this.secondaryBuegelHint) {
        this.secondaryBuegelHint.hidden = !secondaryBuegelMissing;
      }

      // Find add-to-cart buttons
      const productInfo =
        this.closest('.product__info-container') || this.closest('[data-section]');
      const addToCartBtn = productInfo?.querySelector(
        '[name="add"], [data-add-to-cart], .product-form__submit'
      );

      // Update main add-to-cart button
      if (addToCartBtn) {
        addToCartBtn.disabled = isDisabled;
        addToCartBtn.classList.toggle('is-unavailable', hasUnavailableItems);
        addToCartBtn.classList.toggle('is-incomplete', secondaryBuegelMissing);

        // Update button text
        const btnTextEl = addToCartBtn.querySelector('span');
        if (btnTextEl) {
          if (hasUnavailableItems) {
            // Store original text if not already stored
            if (!addToCartBtn.dataset.originalText) {
              addToCartBtn.dataset.originalText = btnTextEl.textContent;
            }
            btnTextEl.textContent = 'Nicht verfügbar';
          } else if (secondaryBuegelMissing) {
            // Store original text if not already stored
            if (!addToCartBtn.dataset.originalText) {
              addToCartBtn.dataset.originalText = btnTextEl.textContent;
            }
            btnTextEl.textContent = 'Bitte beide Bügelfarben wählen';
          } else {
            // Restore original text
            if (addToCartBtn.dataset.originalText) {
              btnTextEl.textContent = addToCartBtn.dataset.originalText;
            }
          }
        }
      }

      // Update mobile sticky cart button
      if (this.stickyAddToCartBtn) {
        this.stickyAddToCartBtn.disabled = isDisabled;
        if (hasUnavailableItems) {
          if (!this.stickyAddToCartBtn.dataset.originalText) {
            this.stickyAddToCartBtn.dataset.originalText = this.stickyAddToCartBtn.textContent;
          }
          this.stickyAddToCartBtn.textContent = 'Nicht verfügbar';
        } else if (secondaryBuegelMissing) {
          if (!this.stickyAddToCartBtn.dataset.originalText) {
            this.stickyAddToCartBtn.dataset.originalText = this.stickyAddToCartBtn.textContent;
          }
          this.stickyAddToCartBtn.textContent = 'Bügelfarben wählen';
        } else {
          if (this.stickyAddToCartBtn.dataset.originalText) {
            this.stickyAddToCartBtn.textContent = this.stickyAddToCartBtn.dataset.originalText;
          }
        }
      }
    }

    /**
     * Get a list of all currently unavailable selections for error display
     * @returns {Array} Array of unavailable item descriptions
     */
    getUnavailableSelections() {
      const unavailable = [];

      if (this.unavailableItems.korb) {
        unavailable.push(`Korb ${this.selectedForm} ${this.selectedFarbe}`);
      }

      if (this.unavailableItems.buegel) {
        unavailable.push(`Bügel ${this.selectedBuegel}`);
      }

      // Note: Accessories are not included here since they don't block the cart
      // They are simply disabled and not selectable

      return unavailable;
    }

    /**
     * Show error notification when trying to add unavailable items to cart
     * @param {Array} unavailableItems - List of unavailable item names
     */
    showUnavailabilityError(unavailableItems) {
      // Create or find error container
      let errorContainer = this.querySelector('[data-unavailability-error]');
      if (!errorContainer) {
        errorContainer = document.createElement('div');
        errorContainer.className = 'bundle-configurator__error-banner';
        errorContainer.setAttribute('data-unavailability-error', '');
        this.querySelector('.bundle-configurator__summary')?.before(errorContainer);
      }

      const itemsList = unavailableItems.join(', ');
      errorContainer.innerHTML = `
        <div class="bundle-configurator__error-content">
          <span class="bundle-configurator__error-icon">!</span>
          <span class="bundle-configurator__error-text">
            Folgende Artikel sind aktuell nicht verfügbar: <strong>${this.escapeHtml(itemsList)}</strong>
          </span>
        </div>
      `;
      errorContainer.hidden = false;

      // Scroll error into view
      errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Auto-hide after 5 seconds
      setTimeout(() => {
        errorContainer.hidden = true;
      }, 5000);
    }

    /**
     * ═══════════════════════════════════════════════════════════════════════════════════
     * ADD TO CART - Fügt das komplette Bundle zum Warenkorb hinzu
     * ═══════════════════════════════════════════════════════════════════════════════════
     *
     * Diese Methode implementiert Shopify's Nested Cart Lines für Bundle-Produkte.
     *
     * WARUM NESTED CART LINES?
     * ────────────────────────
     * Im Shopify-Warenkorb sollen alle Bundle-Teile als zusammengehörige Einheit
     * erscheinen. Dafür nutzen wir die "parent_id" Eigenschaft:
     *
     * ┌─────────────────────────────────────────────────────────────────┐
     * │ ☑ LIEBLINGSKORB Classic Weiß                        139,00 €   │
     * │    └─ Bügelset Gold                                   29,00 €  │
     * │    └─ Deckel (Weiß)                                   49,00 €  │
     * │    └─ Einlegeboden (Weiß)                             39,00 €  │
     * │                                              Summe: 249,00 €   │
     * └─────────────────────────────────────────────────────────────────┘
     *
     * API-STRUKTUR für /cart/add.js:
     * ──────────────────────────────
     * {
     *   items: [
     *     { id: 123, quantity: 1, properties: { _lk_bundle_id: "abc" } },       // Parent (Korb)
     *     { id: 456, quantity: 1, parent_id: 123, properties: {...} },          // Child (Bügel)
     *     { id: 789, quantity: 1, parent_id: 123, properties: {...} },          // Child (Deckel)
     *   ]
     * }
     *
     * WICHTIG - Alle Items in EINEM API-Call:
     * ───────────────────────────────────────
     * Shopify erfordert, dass Parent und alle Children in EINEM Request gesendet werden.
     * Bei separaten Calls würde die parent_id-Referenz nicht funktionieren.
     *
     * _lk_bundle_id Property:
     * ───────────────────────
     * Jedes Bundle bekommt eine eindeutige ID (z.B. "lk_1705312456789_abc").
     * Das verhindert, dass Shopify Items mit gleicher variant_id zusammenfasst,
     * und ermöglicht die visuelle Gruppierung im Cart-Template.
     *
     * _lk_config_url Property:
     * ────────────────────────
     * Speichert die aktuelle Konfigurations-URL, damit der Kunde vom Warenkorb
     * zurück zur Konfiguration navigieren kann ("Bearbeiten"-Link).
     */
    async addToCart() {
      // ═══════════════════════════════════════════════════════════════════════
      // FACEBOOK PIXEL REDIRECT PROTECTION
      // The Facebook Pixel sometimes redirects to /tr/ when tracking AddToCart
      // events for visitors coming from Instagram/Facebook ads (with fbclid).
      // This uses multiple strategies to block the redirect.
      // ═══════════════════════════════════════════════════════════════════════
      let redirectProtectionActive = false;
      let restoreTimeout = null;

      const isFacebookRedirect = (url) => {
        return typeof url === 'string' && (url.includes('facebook.com/tr') || url.includes('facebook.com%2Ftr'));
      };

      // Store the original URL to navigate back if needed
      const originalUrl = window.location.href;
      let urlCheckInterval = null;

      // Aggressive URL polling - checks every 10ms if we're being redirected
      const startUrlPolling = () => {
        urlCheckInterval = setInterval(() => {
          if (isFacebookRedirect(window.location.href)) {
            console.error('[Bundle Configurator] Facebook redirect detected via polling! Navigating back.');
            clearInterval(urlCheckInterval);
            window.stop();
            window.location.href = originalUrl;
          }
        }, 10);
      };

      const stopUrlPolling = () => {
        if (urlCheckInterval) {
          clearInterval(urlCheckInterval);
          urlCheckInterval = null;
        }
      };

      // Store original functions
      const originalOpen = window.open;
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;

      // Handler for beforeunload
      const beforeUnloadHandler = (e) => {
        const destination = document.activeElement?.href || '';
        if (isFacebookRedirect(destination)) {
          console.warn('[Bundle Configurator] Blocking Facebook navigation');
          e.preventDefault();
          e.returnValue = '';
          return '';
        }
      };

      // Handler for click events on links
      const clickHandler = (e) => {
        const link = e.target.closest('a');
        if (link && isFacebookRedirect(link.href)) {
          console.warn('[Bundle Configurator] Blocked Facebook redirect (link click):', link.href);
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      };

      // Handler for form submissions
      const submitHandler = (e) => {
        const form = e.target;
        if (form && form.action && isFacebookRedirect(form.action)) {
          console.warn('[Bundle Configurator] Blocked Facebook redirect (form submit):', form.action);
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      };

      // Watch for dynamically added iframes that might cause redirects
      const mutationCallback = (mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.tagName === 'IFRAME' && isFacebookRedirect(node.src)) {
              console.warn('[Bundle Configurator] Blocked Facebook iframe:', node.src);
              node.remove();
            }
          });
        });
      };

      let mutationObserver = null;

      const blockFacebookRedirect = () => {
        try {
          document.addEventListener('click', clickHandler, true);
          document.addEventListener('submit', submitHandler, true);
          window.addEventListener('beforeunload', beforeUnloadHandler);

          window.open = function (url, ...args) {
            if (isFacebookRedirect(url)) {
              console.warn('[Bundle Configurator] Blocked window.open to Facebook:', url);
              return null;
            }
            return originalOpen.call(window, url, ...args);
          };

          history.pushState = function (state, title, url) {
            if (isFacebookRedirect(url)) {
              console.warn('[Bundle Configurator] Blocked pushState to Facebook:', url);
              return;
            }
            return originalPushState.call(history, state, title, url);
          };

          history.replaceState = function (state, title, url) {
            if (isFacebookRedirect(url)) {
              console.warn('[Bundle Configurator] Blocked replaceState to Facebook:', url);
              return;
            }
            return originalReplaceState.call(history, state, title, url);
          };

          mutationObserver = new MutationObserver(mutationCallback);
          mutationObserver.observe(document.body, { childList: true, subtree: true });

          startUrlPolling();

          redirectProtectionActive = true;
        } catch (e) {
          console.warn('[Bundle Configurator] Could not enable redirect protection:', e);
        }
      };

      const restoreLocation = () => {
        if (restoreTimeout) clearTimeout(restoreTimeout);
        restoreTimeout = setTimeout(() => {
          if (!redirectProtectionActive) return;
          try {
            document.removeEventListener('click', clickHandler, true);
            document.removeEventListener('submit', submitHandler, true);
            window.removeEventListener('beforeunload', beforeUnloadHandler);
            window.open = originalOpen;
            history.pushState = originalPushState;
            history.replaceState = originalReplaceState;
            if (mutationObserver) {
              mutationObserver.disconnect();
              mutationObserver = null;
            }
            stopUrlPolling();
            redirectProtectionActive = false;
          } catch (e) {
            // Ignore restoration errors
          }
        }, 5000);
      };

      // Activate redirect protection before any cart operations
      blockFacebookRedirect();

      // Pre-check availability - only Korb and Bügel block the cart
      // Unavailable accessories are simply not selectable, so they won't be in the cart
      if (this.unavailableItems.korb || this.unavailableItems.buegel) {
        const unavailable = this.getUnavailableSelections();
        // console.warn('Cannot add to cart - unavailable items:', unavailable);
        this.showUnavailabilityError(unavailable);
        restoreLocation();
        return;
      }

      // Pre-check if secondary bügel is required but not selected
      if (this.allowSecondaryBuegel && !this.selectedBuegelSecondary) {
        // console.warn('Cannot add to cart - secondary bügel not selected');
        restoreLocation();
        return;
      }

      const parentItem = this.getParentCartItem();
      if (!parentItem) {
        // console.warn('No parent item (Korb) selected');
        restoreLocation();
        return;
      }

      // Find all add-to-cart buttons to show loading state
      const productInfo = this.closest('.product__info-container') || this.closest('[data-section]');
      const addToCartBtn = productInfo?.querySelector('[name="add"], [data-add-to-cart], .product-form__submit');
      const stickyBtn = this.stickyAddToCartBtn;

      // Add loading state to buttons
      if (addToCartBtn) addToCartBtn.classList.add('btn--loading');
      if (stickyBtn) stickyBtn.classList.add('btn--loading');

      try {
        const parentVariantId = parentItem.id;

        // Generate unique bundle ID for this cart addition
        const bundleId = this.generateBundleId();

        // Build the configuration URL (current URL with all parameters)
        const configUrl = window.location.pathname + window.location.search;

        // Get bundle name from matched rule message (for Function Studio condition matching)
        // Uses message stored at price calculation time (more reliable than calling getMatchingBundleRule again)
        const bundleName = this.dataset.bundleMatchedMessage || this.dataset.bundleName || '';

        // Add bundle ID, name and config URL to parent item properties
        if (!parentItem.properties) {
          parentItem.properties = {};
        }
        parentItem.properties._lk_bundle_id = bundleId;
        parentItem.properties._lk_config_url = configUrl;
        if (bundleName) {
          parentItem.properties._lk_bundle_name = bundleName;
        }

        // Build all items in one array: parent first, then children with parent_id
        const items = [parentItem];

        // Add primary Bügel as child
        const buegelData = this.getSelectedBuegelData('primary');
        if (buegelData && buegelData.variantId) {
          const variantId = parseInt(buegelData.variantId, 10);
          if (!isNaN(variantId) && variantId > 0) {
            const buegelProperties = {
              _lk_bundle_id: bundleId,
              _lk_buegel_sequence: 'primary',
            };
            if (bundleName) {
              buegelProperties._lk_bundle_name = bundleName;
            }
            const buegelDeliveryHint = (buegelData.deliveryHint || '').trim();
            if (buegelDeliveryHint) {
              buegelProperties['Lieferzeit'] = buegelDeliveryHint;
            }
            items.push({
              id: variantId,
              quantity: 1,
              parent_id: parentVariantId,
              properties: buegelProperties,
            });
          }
        }

        // Add secondary Bügel as child (if enabled and selected)
        if (this.allowSecondaryBuegel && this.selectedBuegelSecondary) {
          const buegelDataSecondary = this.getSelectedBuegelData('secondary');
          if (buegelDataSecondary && buegelDataSecondary.variantId) {
            const variantId = parseInt(buegelDataSecondary.variantId, 10);
            if (!isNaN(variantId) && variantId > 0) {
              const buegelSecondaryProperties = {
                _lk_bundle_id: bundleId,
                _lk_buegel_sequence: 'secondary',
              };
              if (bundleName) {
                buegelSecondaryProperties._lk_bundle_name = bundleName;
              }
              const buegelSecondaryDeliveryHint = (buegelDataSecondary.deliveryHint || '').trim();
              if (buegelSecondaryDeliveryHint) {
                buegelSecondaryProperties['Lieferzeit'] = buegelSecondaryDeliveryHint;
              }
              items.push({
                id: variantId,
                quantity: 1,
                parent_id: parentVariantId,
                properties: buegelSecondaryProperties,
              });
            }
          }
        }

        // Add accessories as children
        const optionalAccessories = [];
        const requiredAccessories = [];

        this.accessoryItems.forEach((item) => {
          if (item.hidden) return;
          
          // Check if this item belongs to a bundle group
          const bundleGroupName = item.dataset.bundleGroup;
          if (bundleGroupName) {
            // Find the parent bundle container and check if it's selected
            const parentBundle = this.querySelector(`[data-accessory-bundle][data-bundle-group="${bundleGroupName}"]`);
            if (parentBundle) {
              const bundleCheckbox = parentBundle.querySelector('[data-bundle-checkbox]');
              // Skip this item if the bundle is not checked
              if (!bundleCheckbox || !bundleCheckbox.checked) {
                return;
              }
            }
          }
          
          const checkbox = item.querySelector('input[type="checkbox"]');
          if (checkbox && checkbox.checked) {
            const variantIdStr = checkbox.dataset.accessoryVariantId;
            if (variantIdStr) {
              const variantId = parseInt(variantIdStr, 10);
              if (!isNaN(variantId) && variantId > 0) {
                const accessoryProperties = {
                  _lk_bundle_id: bundleId,
                };
                if (bundleName) {
                  accessoryProperties._lk_bundle_name = bundleName;
                }

                const deliveryHint = checkbox?.dataset?.accessoryDeliveryHint || '';
                if (deliveryHint) {
                  accessoryProperties['Lieferzeit'] = deliveryHint;
                }

                const accessoryItem = {
                  id: variantId,
                  quantity: 1,
                  parent_id: parentVariantId,
                  properties: accessoryProperties,
                };

                const isOptional = item.dataset.vorausgewaehlt !== 'true';
                if (isOptional) {
                  optionalAccessories.push(accessoryItem);
                } else {
                  requiredAccessories.push(accessoryItem);
                }
              }
            }
          }
        });

        // Add required accessories first, then optional
        requiredAccessories.forEach((acc) => items.push(acc));
        optionalAccessories.forEach((acc) => items.push(acc));

        // Add free gifts as children (only when all accessories are selected)
        // Gifts are conditional - customer only gets them with the full bundle
        if (this.areGiftsIncluded()) {
          this.giftItems.forEach((item) => {
            const variantIdStr = item.dataset.giftVariantId;
            if (variantIdStr) {
              const variantId = parseInt(variantIdStr, 10);
              if (!isNaN(variantId) && variantId > 0) {
                const giftProperties = {
                  _lk_bundle_id: bundleId,
                  _lk_is_free_gift: 'true',
                };
                if (bundleName) {
                  giftProperties._lk_bundle_name = bundleName;
                }
                items.push({
                  id: variantId,
                  quantity: 1,
                  parent_id: parentVariantId,
                  properties: giftProperties,
                });
              }
            }
          });
        }

        // console.log('Adding all items in single call:', JSON.stringify(items, null, 2));
        // console.log('Parent item properties:', parentItem.properties);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        const data = await response.json();

        if (!response.ok) {
          const errorMsg = data.description || data.message || 'Failed to add items to cart';
          // console.error('Cart error:', errorMsg, data);
          throw new Error(errorMsg);
        }

        // console.log('All items added successfully:', data);

        // ═══════════════════════════════════════════════════════════════════════
        // SHOPIFY ANALYTICS TRACKING FOR CHILD ITEMS
        // Shopify's default tracking only fires for the parent product. We use
        // Shopify.analytics.publish to fire product_added_to_cart events for all
        // child items (Bügel, accessories, gifts). This ensures Web Pixels
        // (Facebook, GA4, etc.) in Shopify's sandbox receive the events correctly.
        // ═══════════════════════════════════════════════════════════════════════
        if (window.Shopify?.analytics?.publish && data.items && data.items.length > 1) {
          // Skip first item (parent/Korb) - Shopify already tracks it
          const childItems = data.items.slice(1);
          console.log('[Bundle Analytics] Publishing', childItems.length, 'child items to Shopify analytics');

          childItems.forEach((item) => {
            const cartLine = {
              merchandise: {
                id: `gid://shopify/ProductVariant/${item.variant_id}`,
                product: {
                  id: `gid://shopify/Product/${item.product_id}`,
                  title: item.product_title,
                  vendor: item.vendor || '',
                  type: item.product_type || '',
                  untranslatedTitle: item.product_title,
                },
                title: item.variant_title || item.title,
                price: {
                  amount: (parseFloat(item.final_line_price) / 100).toFixed(2),
                  currencyCode: window.Shopify?.currency?.active || 'EUR',
                },
                sku: item.sku || '',
              },
              quantity: item.quantity,
              cost: {
                totalAmount: {
                  amount: (parseFloat(item.final_line_price) / 100).toFixed(2),
                  currencyCode: window.Shopify?.currency?.active || 'EUR',
                },
              },
            };

            console.log('[Bundle Analytics] Publishing product_added_to_cart for:', item.product_title, cartLine);
            window.Shopify.analytics.publish('product_added_to_cart', {
              cartLine: cartLine,
            });
          });
        }

        // Enable sticky cart after first successful add-to-cart (for products without recommended accessories)
        this.enableStickyCart();

        // Remove loading state from buttons
        if (addToCartBtn) addToCartBtn.classList.remove('btn--loading');
        if (stickyBtn) stickyBtn.classList.remove('btn--loading');

        // Dispatch cart:refresh event to update and open cart drawer
        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: { open: true },
          })
        );

        // Restore location after successful cart operation
        restoreLocation();

        return data;
      } catch (error) {
        // console.error('Error adding to cart:', error);
        // Remove loading state from buttons on error
        if (addToCartBtn) addToCartBtn.classList.remove('btn--loading');
        if (stickyBtn) stickyBtn.classList.remove('btn--loading');

        // Restore location on error
        restoreLocation();

        throw error;
      }
    }
  }

  customElements.define('bundle-configurator', BundleConfigurator);
}